import React, { useEffect, useState, useRef } from "react";
import {getAxiosResponse, getAxiosResponseAndSetState, putAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import APIUrls from "../../../services/APIUrls";
import BidAlerts from "./BidAlerts";
import Constants from "../../../Constants";
import DatePickerCalendar from "../../dashboard/calendars/DatePickerCalendar";
import { confirmAlert } from "react-confirm-alert";
import { Link, useParams, useNavigate } from "react-router-dom";
import { checkDateExpired, dateFormat, utcDateTimeWithTimeZone, TIME_LIST, dateDifference, addDaysToDateNoFormat,
  campaignDetailDateWithTimeZone, transformBlankToNull, utcDateTimeWithTimeZoneWithFormat, dateConvertToTimeStamp,
  humanize,checkUpdateBidDateDisabledCondition, ConvertNewLineToBr, dateFormatAccToTimeZone, timeStamp, dateInTimeZone, utcTimeStamp} from "../../../services/Util";
import Select from "react-select";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "./PaymentForm";
import ReactTooltip from "react-tooltip";
import { loginSessionDetail } from "../../../redux/reducers/LoginSessionSlice";
import $ from "jquery";
import EditProjectDateBid from "./EditProjectDateBid";
import { logError } from "../../../services/authApiRoutes/APImethods";
import { handleError } from "../../../services/authApiRoutes/APImethods";
import { calenderIcon, CrossIconForModal } from "../../../AppIcons";
import { ConditionalBlock } from "../../../ConditionalBlock";
import BidNeedMoreTime from "./BidNeedMoreTime";

export default function Bids(prop) {
  const [iterationBidId, setBidId] = useState([]);
  const [bidItemId, setBidItemId] = useState("");
  const navigate = useNavigate()
  const [iteration, setItteration] = useState([]);
  const [preferedVendors, setPreferredVendors] = useState([]);
  const [customerPurchaseOrder, setCustomerPurchaseOrder] = useState([]);
  const [historyItteration, setHistoryItteration] = useState([]);
  const [bidDueTime, setBidDueTime] = useState(-1);
  const [deliveryDueTime, setDeliveryDueTime] = useState(-1);
  const [selectedPO, setSelectedPO] = useState("");
  const [cancelItteration, setCancelItteration] = useState({});
  const [dateValidation, setDateValidation] = useState(false);
  const [receiveQuotes, setReceiveQuotes] = useState(true);
  const [bidSelectDeadlineDate, setBidSelectDeadlineDate] = useState("");
  const [toggleIntialCal, toggleIntialCalFlag] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [bidDueDate, setBidDueDate] = useState("");
  const [toggle, toggleCal] = useState(false);
  const [autoVendorApprove, setAutoApproveVendor] = useState("");
  const [options, setOptions] = useState({});
  const [customerData, setCustomerData] = useState({});
  const projectStatus = prop.projectDetail.displayName[0].status;
  const projectDisplay = prop.projectDetail.displayName[0];
  const [showBidSelectionPopup, toggleBidSelectionPopup] = useState(false);
  const [POSelectionPopup, showPOSelectionPopup] = useState(false);
  const [payload, setPayload] = useState({});
  const [toggleVendorDateModal, setToggleVendorDateModal] = useState(false);
  const [winningBidVendor, setWinningBidVendor] = useState("");
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [deliveryDueDate, setDeliveryDueDate] = useState("");
  const [paymentOptions, setPaymentOptions] = useState(false);
  const [bidSelectionConfirmation, setBidSelectionConfirmation] = useState(false);
  const [showAccountsPayableInfo, setShowAccountsPayableInfo] = useState(true);
  const [showStripeForm, setShowStripeForm] = useState(false);
  const [stripeSelected, setStripeSelected] = useState(false);
  const [showBack, setShowBack] = useState(false);
  const [stripeSelectBidData, setStripeSelectBidData] = useState({});
  const [stripeSelectedBid, setStripeSelectedBid] = useState({});
  const [thankyouNote, setThankyouNote] = useState(false);
  const [cardType, setCardType] = useState("");
  const [poSelectionMandatory, setPoSelectionMandatory] = useState(false);
  const [stripeUserPreference, setStripeUserPreference] = useState("false");
  const [showAccountsPayableForm, setShowAccountsPayableForm] = useState(false);
  const [acctsPayableVerificationNote, setAccountsPayableVerificationNote] = useState(false);
  const [disableNextButton, setDisableNextButton] = useState(false);
  const [accountPayableName, setAccountPayableName] = useState("");
  const [accountPayableEmail, setAccountPayableEmail] = useState("");
  const [accountPayablePhone, setAccountPayablePhone] = useState("");
  const [apNameError, setApNameError] = useState(false);
  const [apEmailError, setApEmailError] = useState(false);
  const [apPhoneError, setApPhoneError] = useState(false);
  const [apNameErrorMsg, setApNameErrorMsg] = useState("");
  const [apEmailErrorMsg, setApEmailErrorMsg] = useState("");
  const [apPhoneErrorMsg, setApPhoneErrorMsg] = useState("");
  const [showAcctsPayablePopup, setShowAcctsPayablePopup] = useState(false);
  const [exceedLimitError, setExceedLimitError] = useState(false);

  const refToggle = useRef(null);
  const refToggle2 = useRef(null);
  const refCalendar = useRef(null);
  const refCalendar2 = useRef(null);
  const custBootstrapDataRedux = useSelector((store) => store.customer_bootstrap_data).value;
  const userTimeZone = custBootstrapDataRedux?.user?.timeZone;
  const locale = custBootstrapDataRedux?.user?.locale.replace("_", "-");
  const { t } = useTranslation();
  const stripeTokenDetails = useSelector((reduxStore) => reduxStore.stripe).value;

  const owner = useSelector((reduxStore) => reduxStore.loginSession).value;
  const itemTaskDisplay = {
    "translation_translated_words":"Already translated (100%)",
    "translation_repeated_words":"Repetitions",
  } 
  const project = prop.projectDetail.resource.projectResource;
  const projectDetailStatus = prop.projectDetail.displayName[0]
  const bidSelectionStatus = projectDetailStatus.status.waitingForBidSelection
  
  const param = useParams();
  function showModel() {
    setTimeout(() => {
      $('.small-dropdown-select .hide').removeClass('hide');
    }, 300);
    $(document.activeElement).addClass('showPopup');
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $('.modelPopup .close').trigger('focus');
    }, 300);
    if (
      options?.features?.STRIPE === false ||
      stripeUserPreference === "false"
    ) {
      setPaymentOptions(false);
      setShowAccountsPayableInfo(false);
      poSelectionMandatory && project.poRequired && project.purchaseOrder === ""
        ? setBidSelectionConfirmation(false)
        : setBidSelectionConfirmation(true);
    } else {
      poSelectionMandatory && project.poRequired && project.purchaseOrder === ""
        ? setPaymentOptions(false)
        : setPaymentOptions(true);
      options?.accountStatus?.verified === false
        ? setShowAccountsPayableInfo(false)
        : setShowAccountsPayableInfo(true);
      setBidSelectionConfirmation(false);
    }
    setShowStripeForm(false);
    setShowBack(false);
     }
  function hideModel() {
    setExceedLimitError(false);
    document.body.classList.remove("modal-open");
    $('.showPopup').trigger('focus');
    $('.showPopup').removeClass('showPopup');
    $('.small-dropdown-select > div').addClass('hide')
  }
  

  const escapeModal = (event) => {
    let allAreFalse = true;
    $('.small-dropdown-select').each(function() {
      if ($(this).find('input').attr('aria-expanded') !== 'false') {
        allAreFalse = false;
        return false;
      }
    });
    if(event.key === Constants.TAB && event.shiftKey) {
      if ($(event.target).hasClass('close')) {
        event.preventDefault();
        if ($('#confirmNeedMoreTime').prop('disabled')) {
          event.preventDefault();
          $('#cancelQuoteDeadline').trigger('focus');
        } else {
          event.preventDefault();
          $('#confirmNeedMoreTime').trigger('focus');
        }
      }
    } else if (event.key === Constants.TAB && !event.shiftKey) {
      if ($(event.target).attr('id') === 'confirmNeedMoreTime' ||
          (($(event.target).attr('id') === 'cancelQuoteDeadline') &&
          $('#confirmNeedMoreTime').prop('disabled'))) {
        event.preventDefault();
        $('.close').trigger('focus');
      }
    } else if (event.key === Constants.ESCAPE
      && allAreFalse
      && !($('.calFirstFocus').length) &&
      !($('.calSecondFocus').length)) {
      if ($('#needMoreTimePopup').length) {
        hideModel();
      }
      else if ($('#editProjectDatesPopup').length) {
        hideDateVendorModel();
      }
    }
  }

  const paymentPopup = (event) => {
    if(event.key === Constants.TAB && !event.shiftKey) {
      if ($('#okay').length) {
        event.preventDefault();
        $('#okay').trigger('focus');
      } else if ($('#nextToPay').length && $(event.target).attr('id') === 'cancelSelectQuote') {
          event.preventDefault();
          $('.group-radio-list input:checked').trigger('focus');
      } else {
        if ($('#cancelSelectQuote').next().is(":focus")) {
          if ($('#confirmBidSelection').is(":focus")) {
            event.preventDefault();
            $('#cancelSelectQuote').trigger('focus');
          } else {
            event.preventDefault();
            if ($('#accounts-payable').prop('checked')) {
              $('#accounts-payable').trigger('focus');
            } else if ($('#stripe').prop('checked')) {
              $('#stripe').trigger('focus');
            }
          }
        }
      }
    }
     else if (event.key === Constants.TAB && event.shiftKey) {
      if ($('#okay').length) {
        event.preventDefault();
        $('#okay').trigger('focus');
      } else if ($('#nextToPay').length && $(event.target).attr('id') === 'stripe') {
        event.preventDefault();
        $('#cancelSelectQuote').trigger('focus');
      } else if ($(event.target).attr('id') === 'accounts-payable' ||
          $(event.target).attr('id') === 'stripe') {
        event.preventDefault();
        $('#cancelSelectQuote').next().trigger('focus');
      } else if ($('#confirmBidSelection').prev().is(":focus")) {
        event.preventDefault();
        $('#confirmBidSelection').trigger('focus');
      }
    } else if (event.key === Constants.ESCAPE) {
      handleCancel();
    }
  }

  const autoBidApproveSelect = (e) => {
    if (e.target.checked) {
      setAutoApproveVendor(true);
    } else {
      setAutoApproveVendor(false);
    }
  };

  const hideExtendDateModel = () =>{
    setBidDueDate('')
    setBidDueTime(-1)
    setDeliveryDueTime(-1)
    setDeliveryDueDate('')
    hideModel()
  }

  const confirmBidAccept = () => {
    var iterationPayload = structuredClone(cancelItteration.resource);
    iterationPayload.status = "customer_accepted";
    var finalPayload = transformBlankToNull(iterationPayload);
    confirmAlert({
      title: "Confirm Final Costs",
      message: <p>{`By clicking Accept, you accept the vendor's cancelation bid and agree to the project's final cost.`}</p>,
      buttons: [
        {
          label: "Accept",
          onClick: () =>
            putAxiosResponse(
              APIUrls.UPDATE_CANCELED_BID_REQUEST(param.id),
              finalPayload
            ).then(()=>{
              prop.refresh('bids')
            }),
        },
        {
          label: "Cancel",
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  };
  const rejectBid = () =>{
    var iterationPayload = structuredClone(cancelItteration.resource);
    iterationPayload.status = "customer_rejected";
    var finalPayload = transformBlankToNull(iterationPayload);
    confirmAlert({
      title: "Reject Final Costs",
      message: <p>{`Click Reject to decline the cancelation bid by the vendor. The vendor will be asked to submit an updated cancelation bid again.`}</p>,
      buttons: [
        {
          label: "Reject",
          onClick: () =>
            putAxiosResponse(
              APIUrls.UPDATE_CANCELED_BID_REQUEST(param.id),
              finalPayload
            ).then(()=>{
              prop.refresh('bids')
            }),
        },
        {
          label: "Cancel",
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  }
  const acceptCancelBid = () => {
    var iterationPayload = structuredClone(cancelItteration.resource);
    iterationPayload.status = "CUSTOMER_ACCEPTED";
    var finalPayload = transformBlankToNull(iterationPayload);
    putAxiosResponse(
      APIUrls.UPDATE_CANCELED_BID_REQUEST(param.id),
      finalPayload
    ).then((res) => {});
  };
  const showCalendarDiliveryDate = () => {
    toggleIntialCal ? toggleIntialCalFlag(false) : toggleIntialCalFlag(true);
    $(document.activeElement).toggleClass('calSecondFocus')
    $('.calSecondFocus').trigger('focus')
    $(document).mouseup(function(e) {
      var bannerCont = $('.caltopset');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleIntialCalFlag(false)
        $('.calSecondFocus').removeClass('calSecondFocus')
     }
     });
    if (toggleIntialCal) {
      var requiredElement = document.querySelector(".dashCalendarMachine");
      if (requiredElement !== null) {
        requiredElement.focus();
      }
    }
  };
  $(".calSecondFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if($('div').hasClass('dashCalendarMachine')){
        setTimeout(() => {
          toggleIntialCalFlag(false)
          $('.calSecondFocus').trigger('focus')
          $('.calSecondFocus').removeClass('calSecondFocus')
        }, 100);
      }
    }
     if (e.key === Constants.TAB && e.shiftKey) {
      if($('div').hasClass('dashCalendarMachine')){
        toggleIntialCalFlag(false)
        $('.calSecondFocus').trigger('focus')
        $('.calSecondFocus').removeClass('calSecondFocus')
      }
    }
  });
  const calculateBidSelectionDeadline = () => {
    var defaultBidDueDate = bidDueDate !== "" ? bidDueDate : project.bidDueDate.utcTimestamp;
    var defaultDeliveryDueDate = deliveryDueDate !== "" ? deliveryDueDate : project.deliveryDueDate.utcTimestamp;

    var differenceInHours = Math.round( (new Date(defaultDeliveryDueDate).getTime() - new Date(defaultBidDueDate).getTime()) / (60 * 60 * 1000) );

    differenceInHours = differenceInHours * 0.25;

    var hoursToAddToBidDueDate = Math.abs(differenceInHours);

    if (hoursToAddToBidDueDate < 2) {
      hoursToAddToBidDueDate = 2;
    }
    
    var updatedDate = new Date(defaultBidDueDate).setHours( new Date(defaultBidDueDate).getHours() + hoursToAddToBidDueDate );

    var bidSelectDeadlineDate = new Date(updatedDate).getTime();
    setBidSelectDeadlineDate(bidSelectDeadlineDate);

    return bidSelectDeadlineDate;
  };
  const redirectChangeOrder = (e,changeOrder) =>{
    e.preventDefault()
    navigate(`/project/${param.id}/changeOrder/${changeOrder.id}`)
  }
  const setTime = (event, type) => {
    if (type === 1) {
      let currentBidDueDate = utcDateTimeWithTimeZone(bidDueDate !== "" ? bidDueDate : project?.bidDueDate?.utcTimestamp, userTimeZone);
      currentBidDueDate.set({
        'hour': parseInt(event.value),
        'minute': 0,
        'second': 0,
        'millisecond': 0,
      })
      setBidDueDate(currentBidDueDate);
      setBidDueTime(event.value);
    } else {
      let currentDeliveryDueDate = utcDateTimeWithTimeZone(deliveryDueDate !== "" ? deliveryDueDate : project?.deliveryDueDate?.utcTimestamp, userTimeZone);
      currentDeliveryDueDate.set({
        'hour': parseInt(event.value),
        'minute': 0,
        'second': 0,
        'millisecond': 0,
      })
      setDeliveryDueDate(currentDeliveryDueDate);
      setDeliveryDueTime(event.value);
    }
  };
  const closeCalendar = (e) => {
    if (e.code === Constants.ESCAPE) {
      if ($('.calFirstFocus').length) {
        setTimeout(() => {
          toggleCal(false);
          $('.calFirstFocus').trigger('focus')
          $('#calFirstFocus').removeClass('calFirstFocus')
        }, 100);
      } else if ($('.calSecondFocus').length) {
        setTimeout(() => {
        toggleIntialCalFlag(false);
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
      }, 100);
      }
    }
  };
  const setDueDate = (event) => {
    let updatedTime = bidDueTime !== -1 ? bidDueTime : parseInt(dateFormatAccToTimeZone(project?.bidDueDate?.utcTimestamp, "H",custBootstrapDataRedux?.user?.timeZone));
    let updatedDateWithTime = new Date(event).setHours(updatedTime)
    setBidDueDate(updatedDateWithTime);
    var latestDiff = 0;
    if (deliveryDueDate !== "") {
      latestDiff = dateDifference(
        new Date(updatedDateWithTime),
        new Date(deliveryDueDate),
        "days"
      );
    }
    var diff = dateDifference( new Date(updatedDateWithTime), new Date(project?.deliveryDueDate?.utcTimestamp), "days");
    
    if (diff > 0 && (latestDiff === 0 || latestDiff > 0)) {
      var nextDayDate = new Date(addDaysToDateNoFormat(updatedDateWithTime,1));
      setDeliveryDueDate(nextDayDate);
    }
    
    $('.calFirstFocus').trigger('focus')
    $('#calFirstFocus').removeClass('calFirstFocus')
    $(document).mouseup(function(e) {
      var bannerCont = $('.calFirstFocus');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        $('.calFirstFocus').trigger('focus')
        $('#calFirstFocus').removeClass('calFirstFocus')
      }
    });
    toggleCal(false);
  };
  const setDeliveryDate = (event) => {
    var selectedBidDueDate = bidDueDate !== "" ? new Date(bidDueDate) : new Date(project?.bidDueDate?.utcTimestamp);
    let updatedTime = deliveryDueTime !== -1 ? deliveryDueTime : parseInt(dateFormatAccToTimeZone(project?.deliveryDueDate?.utcTimestamp, "H",custBootstrapDataRedux?.user?.timeZone));
    let updatedDateWithTime = new Date(event).setHours(updatedTime)
    
    const dileveryDueDate = new Date(updatedDateWithTime);
    if (selectedBidDueDate.getTime() === dileveryDueDate.getTime()) {
      setDateValidation(true);
      return;
    }
    $('.calSecondFocus').trigger('focus')
    $('#calSecondFocus').removeClass('calSecondFocus')
    $(document).mouseup(function(e) {
      var bannerCont = $('.calSecondFocus');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        $('.calSecondFocus').trigger('focus')
        $('#calSecondFocus').removeClass('calSecondFocus')
      }
    });
    setDateValidation(false);
    setDeliveryDueDate(updatedDateWithTime);
    toggleIntialCalFlag(false);
  };

  const selectBid = (iteration) => {
    setTimeout(() => {
      $('#cancelSelectQuote').trigger('focus');
    }, 300);
    setStripeSelectedBid(iteration);
    setWinningBidVendor(iteration.vendor.name);
    var payload = { id: iteration.id, winningBidId: iteration.id };
    setPayload(payload);
    showModel();
    if (
      poSelectionMandatory &&
      project.poRequired &&
      project.purchaseOrder === ""
    ) {
      if (POSelectionPopup) {
        showPOSelectionPopup(false);
      } else {
        showPOSelectionPopup(true);
      }
      if (
        poSelectionMandatory &&
        project.poRequired &&
        project.purchaseOrder === ""
      ) {
        getAllCustomerPurchaseOrder(project.currency);
      }
    } else {
      if (showBidSelectionPopup) {
        toggleBidSelectionPopup(false);
        hideModel();
      } else {
        toggleBidSelectionPopup(true);
        showModel();
        paymentOptions && options?.accountStatus?.verified
          ? setDisableNextButton(false)
          : setDisableNextButton(true);
      }
    }
  };
  const acceptBid = () => {
    putAxiosResponse(APIUrls.BID_REQUEST_BY_ID(param.id), payload).then(
      (res) => {
        getData();
        prop.refresh();
        hideModel();
        showPOSelectionPopup(false);
        toggleBidSelectionPopup(false);
      }
    );
  };
  const allowAutomaticSelect = () => {
    return (
      !options.preferences.TRIAL_MODE_ENABLED &&
      options.permissions["BID_OUT_TO_CW_CHOSEN_VENDORS"] &&
      !options.features.WHITE_LABEL_VENDOR_EXCLUSIVE
    );
  };
  const showCalendarDueDate = () => {
    toggle ? toggleCal(false) : toggleCal(true);
    $(document.activeElement).toggleClass('calFirstFocus')
    $('.calFirstFocus').trigger('focus')
    $(document).mouseup(function(e) {
      var bannerCont = $('.firstCal');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleCal(false)
        $('.calFirstFocus').removeClass('calFirstFocus')
     }
    });
    if (toggle) {
      var requiredElement = document.querySelector(".dashCalendar");
      if (requiredElement !== null) {
        requiredElement.focus();
      }
    }
  };
  $(".calFirstFocus").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      if($('div').hasClass('dashCalendarDeadLine')){
        setTimeout(() => {
          toggleCal(false);
          $('.calFirstFocus').trigger('focus')
          $('.calFirstFocus').removeClass('calFirstFocus')
        }, 100);
      }
    }
    if (e.key === Constants.TAB && e.shiftKey) {
      if($('div').hasClass('dashCalendarDeadLine')){
        toggleCal(false);
        $('.calFirstFocus').trigger('focus')
        $('.calFirstFocus').removeClass('calFirstFocus')
      }
    }
  });
  const setCustomerPO = (e) => {
    setSelectedPO(e.value);
  };
  const getAllCustomerPurchaseOrder = async (currency) => {
    getAxiosResponse(APIUrls.CUSTOMER_PURCHASE_ORDER).then((res) => {
      if (res?.data?.data && res?.data?.data.length > 0) {
        var purchaseOrderData = res?.data?.data.filter(data => (currency !== "" && data.currency === currency)).map((data) => ({
          value: data,
          label: data.shortDisplay,
        }));
        setCustomerPurchaseOrder(purchaseOrderData);
      }
    });
  };
  

  const canSelectBid = () =>{
    var projectInSelectableState =  options?.roleSet?.customerType &&   options?.permissions?.APPROVE_BID &&  projectStatus?.inBidOut;
    return  projectInSelectableState && project?.userCanAlterProject &&  (options?.accountStatus?.verified ||  project?.stripeEnabled);
  }

  const getBidStatus = (iterationStatus, iteration, index) => {
    var vendorId = iteration.vendor.id;
    var status = iterationStatus[vendorId];
    if (status.bidStatus.rejectedByVendor) {
      return <p>Vendor Declined</p>;
    } else if (status.bidStatus.selectable && index === 0 && canSelectBid() && iteration?.canContextUserApproveBid) {
      return (
        <button
          className="btn-bold white-space"
          onClick={() => selectBid(iteration)}
        >
          Select Quote
        </button>
      );
    } else if (
      !status.bidStatus.bidDetailsViewableByCustomer ||
      status.bidStatus.pendingVendorApproval
    ) {
      return <p>Not Submitted</p>;
    } else if (status.bidStatus.vendorAccepted) {
      return <p>Vendor Accepted</p>;
    } else if (
      status.bidStatus.vendorSubmitted ||
      status.bidStatus.value === "CUSTOMER_REJECTED"
    ) {
      return <p>Submitted</p>;
    } else if (status.bidStatus.customerAccepted) {
      return (
        <>
          <p>
            Selected{" "}
            {iteration.changeOrder !== ""
              ? campaignDetailDateWithTimeZone(
                  iteration.createdDate,
                  custBootstrapDataRedux?.user?.timeZone
                )
              : project.translationStartDate.dateWithTime}
          </p>
        </>
      );
    } else if (status.bidStatus.expired) {
      return <p>Expired</p>;
    } else {
      return <p>Not Submitted</p>;
    }
  };
  const showDateVendorUpdateModel = () => {
    setToggleVendorDateModal(true);
    showModel();
  };
  const hideDateVendorModel = () => {
    setToggleVendorDateModal(false);
    hideModel();
  };
  function SubbreakdownShow(id,status) {
    if(iteration  && iteration.length > 0){
      setItteration(getVendorPriceBreakDown(iteration,id,status))
    }
    bidItemId === id ? setBidItemId("") : setBidItemId(id);
  }
  function breakdownShow(id) {
    var filtered = iterationBidId.filter((ids)=>{
      return ids !== id
    })
    iterationBidId.includes(id)  ? setBidId(filtered) : setBidId((current)=>[...current,id]);
  }

  const handleCancel = () => {
    setPaymentOptions(true)
    setDisableNextButton(false)
    setStripeSelected(false);
    setShowAccountsPayableInfo(false);
    showPOSelectionPopup(false);
    toggleBidSelectionPopup(false)
    document.body.classList.remove("set-rightBtn");
    hideModel();
  };

  const handleBack = () => {
    updateReviewOrderDisplay(false);
    document.body.classList.add("set-rightBtn");
  };

  const purchase = async () => {
    try {
      const response = await putAxiosResponse(
        APIUrls.STRIPE_SELECT_BID(param.id, stripeSelectedBid.id) +
          "&stripeToken=" +
          stripeTokenDetails?.id +
          "&displayedCost=" +
          stripeSelectBidData?.due?.value
      );
      if (
        response.data?.data?.statusCodeValue === 200 ||
        response.data.status === "success"
      ) {
        setPaymentOptions(false);
        setBidSelectionConfirmation(false);
        setShowBack(false);
        setTimeout(() => {
          $('#okay').trigger('focus')
        }, 100);
        showPOSelectionPopup(false);
        setThankyouNote(true);
      }
    } catch (error) {
      const errorMessage = "Error in purchase:";
      logError(errorMessage, error);    }
  };

  const finalizePayment = () => {
    hideModel();
    prop.refresh();
  };

  const handleClose = () => {
    setPaymentOptions(true);
    toggleBidSelectionPopup(false)
    setAccountsPayableVerificationNote(false);
    setShowAccountsPayableForm(false);
  };

  const updatePurchaseOrder = () => {
    var copyProject = structuredClone(project);
    copyProject.purchaseOrder = selectedPO;
    var payload = transformBlankToNull(copyProject);
    putAxiosResponse(APIUrls.PROJECT(param.id), payload).then((res) => {
      toggleBidSelectionPopup(true);
      showPOSelectionPopup(false);
      if (options?.features?.STRIPE && stripeUserPreference === "true") {
        setPaymentOptions(true);
        setBidSelectionConfirmation(false);
      } else {
        setPaymentOptions(false);
        setBidSelectionConfirmation(true);
      }
      getData();
    });
  };

  const paymentMethodSelectionHandler = () => {
    if (stripeSelected) {
      setShowBack(true);
    } else {
      if (showAccountsPayableForm) {
        let customerPayload = Object.assign({}, customerData);
        customerPayload.financialContactEmail = accountPayableEmail;
        customerPayload.financialContactName = accountPayableName;
        customerPayload.financialContactPhone = accountPayablePhone;
        putAxiosResponse(
          APIUrls.CUSTOMER_FINANCIAL_CONTACT,
          transformBlankToNull(customerPayload)
        ).then((res) => {
          if (res.data?.data?.statusCodeValue === 200) {
            setPaymentOptions(false);
            setShowAccountsPayableForm(false);
            setDisableNextButton(true);
            setAccountsPayableVerificationNote(true);
          }
          if (res.data?.data?.statusCodeValue === 400) {
            let apiErrors = res.data.data.body.errors;
            Object.keys(apiErrors).map((errorKey) => {
              switch (errorKey) {
                case "financialContactEmail":
                  setApEmailError(true);
                  setApEmailErrorMsg(apiErrors[errorKey]);
                  break;
                case "financialContactName":
                  setApNameError(true);
                  setApNameErrorMsg(apiErrors[errorKey]);
                  break;
                case "financialContactPhone":
                  setApPhoneError(true);
                  setApPhoneErrorMsg(apiErrors[errorKey]);
                  break;
                default:
                  break;
              }
            });
            setPaymentOptions(true);
            setShowAccountsPayableForm(true);
          }
        });
      } else {
        setPaymentOptions(false);
        setShowAccountsPayableForm(false);
        setBidSelectionConfirmation(true);
      }
      setShowBack(false);
   }
    setTimeout(() => {
      $('#confirmBidSelection').trigger('focus');
    }, 300);
  };

  const handleAcctsPayableNoteCancel = () => {
    document.body.classList.remove("modal-open");
  };

  const handleEnter = () => {
    let customerPayload = Object.assign({}, customerData);
    customerPayload.financialContactEmail = accountPayableEmail;
    customerPayload.financialContactName = accountPayableName;
    customerPayload.financialContactPhone = accountPayablePhone;
    putAxiosResponse(
      APIUrls.CUSTOMER_FINANCIAL_CONTACT,
      transformBlankToNull(customerPayload)
    ).then((res) => {
      if (res.data?.data?.statusCodeValue === 200) {
        setAccountsPayableVerificationNote(true);
      }
      if (res.data?.data?.statusCodeValue === 400) {
        setToggleVendorDateModal(false);
        setShowAcctsPayablePopup(true);
        let apiErrors = res.data.data.body.errors;
        Object.keys(apiErrors).map((errorKey) => {
          switch (errorKey) {
            case "financialContactEmail":
              setApEmailError(true);
              setApEmailErrorMsg(apiErrors[errorKey]);
              break;
            case "financialContactName":
              setApNameError(true);
              setApNameErrorMsg(apiErrors[errorKey]);
              break;
            case "financialContactPhone":
              setApPhoneError(true);
              setApPhoneErrorMsg(apiErrors[errorKey]);
              break;
            default:
              break;
          }
        });
      }
    });
  };
  
  const PriceBreakDownOptions = [
    "translation_translated_words" ,
    "translation_repeated_words" ,
    "translation_fuzzy_match_words",
    "translation_new_words",
    "translation_75_84_fuzzy_match_words",
    "translation_85_94_fuzzy_match_words",
    "translation_95_99_fuzzy_match_words",
    "in_context_exact",
    "machine_translated"
  ]
  const checkFinancialInformation = () => {
    if (
      customerData.financialContactEmail !== "" &&
      customerData.financialContactName !== "" &&
      customerData.financialContactPhone !== ""
    ) {
      return false;
    }
    return options?.accountStatus?.verified ? false : true;
  };

  const handleAccountsPayable = (event) => {
    if (event.target.checked) {
      let showAPForm = checkFinancialInformation();
      setShowAccountsPayableForm(showAPForm);
      paymentOptions && options?.accountStatus?.verified
        ? setDisableNextButton(showAPForm)
        : setDisableNextButton(!showAPForm);
      setShowAccountsPayableInfo(true);
      setShowStripeForm(false);
      setStripeSelected(false);
      setExceedLimitError(false);
      document.body.classList.remove("set-rightBtn");
    }
  };

  const handleAPInfo = (event) => {
    switch (event.target.id) {
      case "apc-name":
        setAccountPayableName(event.target.value);
        setApNameError(false);
        setApNameErrorMsg("");
        break;
      case "apc-email":
        setAccountPayableEmail(event.target.value);
        setApEmailError(false);
        setApEmailErrorMsg("");
        break;
      case "apc-phone":
        setAccountPayablePhone(event.target.value);
        setApPhoneError(false);
        setApPhoneErrorMsg("");
        break;
      default:
        break;
    }
  };
const alreadyIterated = (id) =>{
  var itId = `iteration-${id}`
  $(`[id=${itId}]:eq(1)`).css("display","none");
  return {}
}
  const getStripeSelectBid = () => {
    getAxiosResponse(APIUrls.STRIPE_SELECT_BID(param.id, stripeSelectedBid.id))
    .then((res) => {
      if(res?.data?.data?.length !== 0) {
        setStripeSelectBidData(res.data.data);
        setShowAccountsPayableInfo(false);
        setShowAccountsPayableForm(false);
        setStripeSelected(true);
        setDisableNextButton(false);
        if(!res?.data?.data?.aboveLimit) {
          setShowStripeForm(true);
          document.body.classList.add("set-rightBtn");
        } else {
          setExceedLimitError(true);
        }
      }
    })
  };

  const handleStripe = (event) => {
    if (event.target.checked) {
      getStripeSelectBid();
    }
  };
  const getData = () => {
    getAxiosResponse(
      APIUrls.GET_BID_ITTERATION(param.id) + `?excludeMaxIteration=false`
    )
      .then((res) => {        
        if (res.data !== "") {
          if (
            projectStatus.code !== "REMOVED_IN_BID_OUT" &&
            (projectStatus.cancelled || projectStatus.inCancellation)
          ) {
            let iteration=res?.data?.data
            if(iteration && iteration.length > 0){
              setHistoryItteration(getVendorPriceCalculationData(iteration));
            }
            getAcceptedItteration();
          } else {
            let iteration=res?.data?.data
            if(iteration  && iteration.length > 0){
              setItteration(getVendorPriceCalculationData(iteration));
            }
          }
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const getVendorPriceCalculationData=(iteration)=>{
    return iteration?.map(iterate=>{
      return {...iterate,resource:{...iterate?.resource ,bids:iterate?.resource?.bids?.map(bid=>{
       return {...bid,bidItems:bid?.bidItems.map(item=>{
         return {...item,itemStatus:false}
       })} 
    })}
   }})
  } 

  const getVendorPriceBreakDown=(iteration,id,status)=>{
    return iteration?.map(iterate=>{
      return {...iterate,resource:{...iterate?.resource ,bids:iterate?.resource?.bids?.map(bid=>{
       return {...bid,bidItems:bid?.bidItems.map(item=>{
            if(item.id===id){
              return {...item,itemStatus:status}
            }
            return item;
       })} 
    })}
   }})
  } 


  const getAcceptedItteration = () => {
    getAxiosResponse(APIUrls.CANCELED_BID_ITTERATION(param.id))
      .then((res) => {
        if (res.data !== "" && res.data.data) {
          setCancelItteration(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  const showBidUpdatePopup = () =>{
    return (!(showBidSelectionPopup || POSelectionPopup || showAcctsPayablePopup));
  }
  
  const updateDeadlineDate = () => {
    var error = {
      bidDueDate: "",
      deliveryDueDate: "",
      vendor: "",
    };
    if (bidDueDate === "") {
      error.bidDueDate = "error";
      setErrorData(error);
    }
    if (deliveryDueDate === "") {
      error.deliveryDueDate = "error";
      setErrorData(error);
    }

    if (errorData.length === 0) {
      if (bidDueDate !== "") {
        project.bidDueDateChanged = true;
        project.bidDueDate = timeStamp(bidDueDate, custBootstrapDataRedux?.user?.timeZone);
        project.bidDueDateDisplay = dateFormat(
          bidDueDate,
          Constants.DATE_IN_WORDS
        );
        project.bidDueDateEditable = true;
        project.bidDueDateEditable = true;
        project.bidDueDateHour = bidDueTime;
        project.bidDueDateId = "ProjectDatesViewbidDueDate";
        project.bidDueDateEvent = "";
      }
      if (deliveryDueDate !== "") {
        project.deliveryDueDateChanged = true;
        project.deliveryDueDate = timeStamp(deliveryDueDate, custBootstrapDataRedux?.user?.timeZone);
        project.deliveryDueDateDisplay = dateFormat(
          deliveryDueDate,
          Constants.DATE_IN_WORDS
        );
        project.deliveryDueDateEditable = true;
        project.deliveryDueDateHour = deliveryDueTime;
        project.deliveryDueDateId = "ProjectDatesViewdeliveryDueDate";
        project.deliveryDueDateEvent = "";
      }
      if (selectedVendors.length > 0) {
        project.preferredVendors = selectedVendors;
      }
      project.bidSelectDeadlineDate = new Date(bidSelectDeadlineDate);
      project.bidSelectDeadlineDisplay =
        dateFormat(bidSelectDeadlineDate, Constants.DATE_IN_WORDS) +
        " at " +
        dateFormat(bidSelectDeadlineDate, Constants.HOUR_AM_PM);
      project.bidSelectDeadlineDateEvent = "";
      project.doLetCloudwordsChoose = false;
      project.biddingEnabled = true;
      project.biddingEnabled = true;
      project.isExternalBidless = false;
      project.isInternalTranslator = false;
      project.isMachineTranslation = false;
      project.errors = {};
      project.status = "SUBMITTED_FOR_BIDS";
      var payload = transformBlankToNull(project);
      putAxiosResponse(APIUrls.PROJECT(project.id), payload).then((res) => {
        prop.refresh();
        hideModel();
      });
    }
  };
  useEffect(() => {
    getAxiosResponse(APIUrls.PREFERRED_VENDORS(project.userGroup.id)).then(
      (res) => {
        var vendors = res?.data?.data.map((preferredVendor) => ({
          label: preferredVendor.vendor.name,
          value: {
            id: preferredVendor.vendor.id,
            name: preferredVendor.vendor.name,
          },
        }));
        setPreferredVendors(vendors);
      }
    );
  }, [project]);

  useEffect(() => {
    if(bidDueTime !== -1 || bidDueDate !== "" || deliveryDueDate !== "" || deliveryDueTime !== -1) {
      calculateBidSelectionDeadline();
    }
  }, [bidDueTime, bidDueDate, deliveryDueDate, deliveryDueTime]);

  useEffect(() => {
    const dateTimestamp = dateConvertToTimeStamp();
    getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA).then((res) => {
      setOptions(res.data.data);
      if (res.data?.data?.features?.STRIPE === false) {
        setPaymentOptions(false);
        setBidSelectionConfirmation(true);
      } else {
        setPaymentOptions(true);
        setBidSelectionConfirmation(false);
      }
    });

    getAxiosResponseAndSetState(
      APIUrls.GET_CUSTOMER_INFORMATION,
      setCustomerData
    );

    getAxiosResponse(APIUrls.PO_MANDATORY)
      .then((res) => {
        if (res.data.data.poForcedByAdmin || res.data.data.poForcedByUser) {
          setPoSelectionMandatory(true);
        } else {
          setPoSelectionMandatory(false);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(
      APIUrls.CUSTOMER_ORG_PREFERENCE +
        `?preference=STRIPE_ENABLED&_=${dateTimestamp}`
    )
      .then((res) => {
        if (res.data.code === 200) {
          setStripeUserPreference(res.data.data.status);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getData();
  }, []);

  const getBidDetailsViewableByCustomer = (iteration, index) => {
    var vendorId = iteration.resource.bids[index]?.vendor.id;
    return iteration?.displayName[0][vendorId]?.bidStatus
      ?.bidDetailsViewableByCustomer;
  };
  const updateReviewOrderDisplay = (state) => {
    if (state === true) {
      setShowBack(true);
      setPaymentOptions(false);
      setTimeout(() => {
        $('.midFocus').trigger('focus')
      });
    } else {
      setShowBack(false);
      setPaymentOptions(true);
      setTimeout(() => {
        $('#nextToPay').trigger('focus')
      });
      
    }
  };
  $(".backBtn").on("keydown", function (e) {
    if (e.key === Constants.TAB) {
     if (e.shiftKey === true) {
        e.preventDefault();
        $("#cancelSelectQuote").trigger("focus");
      }
    }
  });
  $("#cancelSelectQuote").on("keydown", function (e) {
    if (e.key === Constants.TAB) {
      if (e.shiftKey === false) {
        e.preventDefault();
        $(".backBtn").trigger("focus");
        $('.nextPopup').trigger("focus");
      }
    }
  });

  const setCard = (card) => {
    if (card !== "unknown") {
      setCardType(card);
    }
  };
  useEffect(()=>{
    $.each($('.react-calendar__tile'), function( index, value ) {
      $(value).attr('aria-label', value.children[0].ariaLabel);
    });
  });
  const enterAcctsPayableInformation = () => {
    setShowAcctsPayablePopup(true);
    setApEmailError(false);
    setApEmailErrorMsg("");
    setApNameError(false);
    setApNameErrorMsg("");
    setApPhoneError(false);
    setApPhoneErrorMsg("");
    showModel();
  };

  const showAccountPayableStatus = () => {
    if (
      options?.accountStatus?.status === "UNVERIFIED" &&
      projectStatus.inBidOut
    ) {
      if (
        customerData.financialContactName !== "" &&
        customerData.financialContactEmail !== "" &&
        customerData.financialContactPhone !== "" &&
        options?.accountStatus?.status === "UNVERIFIED"
      ) {
        if (!options?.features?.STRIPE) {
          return (
            <div className="bids-table mar-bot14">
              <ul>
                <span
                  role="button"
                  aria-label="error"
                  className="alert-icon mar-bot14"
                  tabIndex="0"
                >
                  You cannot select a winning quote for your project because your
                  Accounts Payable Contact information has not been verified by
                  OPAL-Marketing yet. As soon as this information has been verified,
                  you will be able to select the winning quote for this project.
                  Please contact{" "}
                  <a href="mailto:accountsreceivable@cloudwords.com">
                    accountsreceivable@cloudwords.com
                  </a>{" "}
                  if you have any questions.
                </span>
              </ul>
            </div>
          );
        } else {
          return <></>;
        }
      } else if (
        !(
          options.roleSet.value === "ROLE_CUSTOMER" &&
          options.edition === "FREE_TRIAL"
        )
      ) {
        return (
          <div className="bids-table mar-bot14">
            <ul>
              <span
                role="button"
                aria-label="error"
                className="alert-icon mar-bot14"
                tabIndex="0"
              >
                <strong>
                  {owner.firstName}, if you don't want to pay via credit card,
                  you may submit your accounts payable information.
                </strong>
                <br />
                Accounts Payable verification may take up to five business days.{" "}
                <a onClick={enterAcctsPayableInformation}>
                  Enter Accounts Payable Information.
                </a>
              </span>
            </ul>
          </div>
        );
      }
    }
  };

  const GetBidSelectionDeadlineDate = () => {
    let deadlineDate;
    let timeLabel;
    if(bidSelectDeadlineDate !== "") {
      deadlineDate = dateFormat(new Date(bidSelectDeadlineDate), Constants.DATE_IN_WORDS);
      timeLabel = TIME_LIST.find((time) => time.value === parseInt(dateFormat( bidSelectDeadlineDate, "H"))).label
    } else {
      deadlineDate = dateFormatAccToTimeZone( project.bidSelectDeadlineDate?.utcTimestamp, Constants.DATE_IN_WORDS, custBootstrapDataRedux?.user?.timeZone );
      timeLabel = TIME_LIST.find((time) => time.value === parseInt(dateFormatAccToTimeZone( project.bidSelectDeadlineDate?.utcTimestamp, "H", custBootstrapDataRedux?.user?.timeZone))).label
    }
    return `${deadlineDate} at ${timeLabel}`;
  }

  return projectDisplay.status.code !== Constants.PROJECT_STATUS.PROJECT_PREPARING_TM &&
    projectStatus.code !== Constants.PROJECT_STATUS.SOURCE_SYNC_FAILED && projectDisplay.status.code !== Constants.PROJECT_STATUS.EXTRACT_XLIFF_FROM_OFFLINE_FILE ? (
    <div className="listing-content relative">
      {projectDisplay.bidSelectionExpired ? (
        <div className="error-in-bids flex-center">
          <div className="alert">
            None of the vendor(s) that this project was sent to have submitted a
            quote. Clicking "Update and Request Quotes Again" will allow you to
            update your project details and request quote again. Alternatively,
            you can{" "}
            <Link to={`/project-details-edit/${param.id}`}>
              cancel this project
            </Link>
            .
          </div>
          <button className="btn" onClick={showModel}>
            Update and Request Quotes Again
          </button>
        </div>
      ) : (
        <BidAlerts
          pojStatus={projectStatus.code}
          projectId={param.id}
          funct={showDateVendorUpdateModel}
          redirect={prop.funct}
        />
      )}

      {projectStatus.code === Constants.PROJECT_STATUS.NO_BID_SUBMITTED ||
      projectStatus.code === Constants.PROJECT_STATUS.IN_CANCELLATION_WAITING_FOR_CUSTOMER ||
      projectStatus.code === Constants.PROJECT_STATUS.ALL_BID_REJECTED ||
      projectStatus.code === Constants.PROJECT_STATUS.IN_CANCELLATION_WAITING_FOR_VENDOR ||
      projectStatus.code === Constants.PROJECT_STATUS.BID_SELECTION_EXPIRED ||
      projectStatus.code === Constants.PROJECT_STATUS.CHANGE_ORDER_REQUESTED ||
      projectStatus.code === Constants.PROJECT_STATUS.PREPARING_CHANGE_ORDER_TM ||
      projectStatus.code === Constants.PROJECT_STATUS.VENDOR_REJECTED ? (
        <div className="mar-bot40">
          {projectStatus.code === "cancelled" ||
          projectStatus.code === Constants.PROJECT_STATUS.IN_CANCELLATION_WAITING_FOR_VENDOR ||
          projectStatus.code === Constants.PROJECT_STATUS.IN_CANCELLATION_WAITING_FOR_CUSTOMER ? (
            ''
          ) : (
            projectStatus.code === Constants.PROJECT_STATUS.CHANGE_ORDER_REQUESTED ?
            <>
          
          <div className="bids-table pt-10">
          <h6>Quote Request</h6>
          {projectStatus.code === "in_translation" ? (
            <p className="small-text">Your project is underway.</p>
          ) : projectStatus.code === "waiting_for_bid_selection" ? (
            <p className="small-text">
              You need to select a winning quote for this project.
            </p>
          ) : project.status.inActiveTranslation ?
          <p className="small-text">Your project is underway.</p>:
           (
            <p className="small-text">You have requested quote from vendors.</p>
          )}
          <ul>
              <li>
                <div className="title">Source Language</div>
                <div className="text">
                  {projectDisplay.sourceLanguage.display}
                </div>
              </li>
              <li>
                <div className="title">Project Currency</div>
                <div className="text">{projectDisplay.currency?.label}{'('+projectDisplay.currency?.code+')'}</div>
              </li>
              {project.poRequired ? 
                <li>
                  <div className="title">PO Number</div>
                  <div className="text">
                    {project.purchaseOrder !== ""
                      ? project.purchaseOrder.shortDisplay
                      : "None selected"}
                  </div>
                </li> : ""}
              </ul>
          </div>
           
</> : ''
          )}
        </div>
      ) : (
        <div className="project-information project-detail-page">
          {showAccountPayableStatus()}
          {projectStatus.code === Constants.PROJECT_STATUS.IN_CANCELLATION_WAITING_FOR_CUSTOMER ||
      projectStatus.code === Constants.PROJECT_STATUS.IN_CANCELLATION_WAITING_FOR_VENDOR ? (
        <div className="mar-bot25">
          {" "}
          <div className="source-header flex-center source-file">
            <h4>Project Cancelation Work Adjustment</h4>
          </div>
          <div>
            <ul>
              <li>
                <strong>Final Charges</strong>
              </li>
              <li>All prices are in {projectDisplay.currency.code} ({projectDisplay.currency?.pluralLabel})</li>
            </ul>
          </div>
        </div>
      ) : <>
      
          <h6>Quote Request</h6>
          {projectStatus.code === "in_translation" ? (
            <p className="small-text">Your project is underway.</p>
          ) : projectStatus.code === "waiting_for_bid_selection" ? (
            <p className="small-text">
              You need to select a winning quote for this project.
            </p>
          ) :  projectStatus.inActiveTranslation ?
          <p className="small-text">Your project is underway.</p>:
           (
            <p className="small-text">You have requested quote from vendors.</p>
          )}
</>}
   
          <div
            className={
              projectStatus.bidSelectionExpired || 
            projectStatus.code === Constants.PROJECT_STATUS.IN_CANCELLATION_WAITING_FOR_VENDOR ||
            projectStatus.code === Constants.PROJECT_STATUS.IN_CANCELLATION_WAITING_FOR_CUSTOMER
                ? "bids-table hide"
                : "bids-table"
            }
          >
            <ul>
              <li>
                <div className="title">Source Language</div>
                <div className="text">
                  {projectDisplay.sourceLanguage.display}
                </div>
              </li>
              {projectStatus.inBidOut ? (
                <>
                  <li>
                    <div className="title">Quote Due Date</div>
                    <div className="text">
                      {projectDisplay.bidDueDate.dateWithTime}
                    </div>
                  </li>
                  <li>
                    <div className="title">Quote Selection Deadline</div>

                    <div className="text">
                      {projectDisplay?.bidSelectionDeadlineDate?.dateWithTime}
                      {project.userCanAlterProject ? (
                        <Link
                          href=""
                          onClick={showModel}
                        >
                          Need more time?
                        </Link>
                      ) : (
                        ""
                      )}
                    </div>
                  </li>
                </>
              ) : (
                ""
              )}
              <li>
                <div className="title">Project Currency</div>
                <div className="text">{projectDisplay.currency?.label}{'('+projectDisplay.currency?.code+')'}</div>
              </li>
              {project.poRequired ? (
                <li>
                  <div className="title">PO Number</div>
                  <div className="text">
                    {project.purchaseOrder !== ""
                      ? project.purchaseOrder.shortDisplay
                      : "None selected"}
                  </div>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
        </div>
      )}
      {projectStatus.code === Constants.PROJECT_STATUS.IN_CANCELLATION_WAITING_FOR_CUSTOMER ||
      projectStatus.code === Constants.PROJECT_STATUS.IN_CANCELLATION_WAITING_FOR_VENDOR ? (
        <div className="mar-bot25">
          {" "}
          <div className="source-header flex-center source-file">
            <h4>Project Cancelation Work Adjustment</h4>
          </div>
          <div>
            <ul>
              <li>
                <strong>Final Charges</strong>
              </li>
              <li> All prices are in {projectDisplay.currency.code} ({projectDisplay.currency?.pluralLabel})</li>
            </ul>
          </div>
        </div>
      ) : (
        ""
      )}
      {iteration?.length !== 0  ? (
        <div className="relative table-responsive">
          <table className="bids-table-list relative 1" aria-label="Bid History">
            <thead>
              <tr>
                <th>Vendor</th>
                <th>Total</th>
                <th>Quote Status</th>
              </tr>
            </thead>
            <tbody>
            </tbody>
            {iteration.map((iterations, iterationIndex) => {
              return (
                <tbody key={iterationIndex}>
                  <tr aria-live="polite" aria-label={dateFormat(iterations.resource.startDate,'ll')} id={`iteration-${iterations.resource.iteration}`} style={alreadyIterated(iterations.resource.iteration)}>
                           <td className="quote_requested" colSpan={6} aria-live="polite" aria-label={dateFormat(iterations.resource.startDate,'ll')}>
                           {
                           iterations?.resource?.bids[0]?.changeOrder !== '' ?
                             <div><Link onClick={(e)=>redirectChangeOrder(e,iterations.resource.bids[0].changeOrder)}>Change order</Link> Quote Requested: {utcDateTimeWithTimeZoneWithFormat(iterations.resource.bids[0].changeOrder.createdDate,
                               Constants.DATE_FORMAT_MM_DD_YYYY_HH_MM_SS,
                               custBootstrapDataRedux?.user?.timeZone
                             )}</div> : 
                             <div>Quote Requested: {iterations?.resource?.startDate.dateWithTime}</div>
                           }
                           </td>
                         </tr>
                  {!iterations.displayName.bidDetailsViewableByCustomer &&
                  iterations.displayName.pendingVendorApproval ? (
                    <tr>
                      <td>
                        <span
                          className="blue head"
                          role="button"
                          aria-label={
                            iterations.resource.bids[iterationIndex].vendor
                              ?.name
                          }
                          tabIndex="0"
                        >
                          {
                            iterations.resource.bids[iterationIndex].vendor
                              ?.name
                          }
                        </span>
                      </td>
                      
                      <td>
                        <button className="not-submit">Not Submitted</button>
                      </td>
                    </tr>
                  ) : (iterations?.resource?.bids && iterations?.resource?.bids?.length > 0 && 
                    iterations.resource.bids.map((bid, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>
                                <Link to={`/vendors/${bid?.vendor?.id}`}>{bid?.vendor?.name}</Link>
                              {getBidDetailsViewableByCustomer(
                                iterations,
                                index
                              ) ? (
                                <button
                                  className={
                                    iterationBidId.includes(bid.id)
                                      ? "breakdown flex-center show-main"
                                      : "breakdown flex-center"
                                  }
                                  onClick={() => breakdownShow(bid?.id)}
                                  tabIndex="0"
                                  aria-expanded={iterationBidId.includes(bid.id) ? "true" : "false"}
                                  aria-label="Pricing Breakdown"
                                >
                                  <span>Pricing Breakdown </span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M12.8245 7.79075L10.0011 10.6141L7.17781 7.79075L5.87614 9.08325L10.0011 13.2083L14.1261 9.08325L12.8245 7.79075ZM10.0011 0.833252C4.94114 0.833252 0.834473 4.93992 0.834473 9.99992C0.834473 15.0599 4.94114 19.1666 10.0011 19.1666C15.0611 19.1666 19.1678 15.0599 19.1678 9.99992C19.1678 4.93992 15.0611 0.833252 10.0011 0.833252ZM10.0011 17.3333C5.94947 17.3333 2.66781 14.0516 2.66781 9.99992C2.66781 5.94825 5.94947 2.66659 10.0011 2.66659C14.0528 2.66659 17.3345 5.94825 17.3345 9.99992C17.3345 14.0516 14.0528 17.3333 10.0011 17.3333Z"
                                      fill="#1D4ED8"
                                    />
                                  </svg>
                                </button>
                              ) : (
                                ""
                              )}
                            </td>
                            
                            <td>
                              {getBidDetailsViewableByCustomer(
                                iterations,
                                index
                              ) ? (
                                <div className="dollar">
                                  {bid.totalBidCost?.display}
                                </div>
                              ) : (
                                ""
                              )}
                            </td>
                            <td>
                              {options.features !== undefined ? (
                                !(
                                  options?.features?.STRIPE &&
                                  stripeUserPreference === "true"
                                ) &&
                                !options?.accountStatus?.verified &&
                                getBidStatus(
                                  iterations.displayName[0],
                                  bid,
                                  iterationIndex
                                ).props.children === "Select Quote" ? (
                                  <div>
                                    <div className="tooltip-container bids-tooltip">
                                      <p>Submitted</p>
                                      <p
                                        tabindex={0}
                                        data-events={["focus"]}
                                        data-eventsoff={["blur"]}
                                        data-padding="10px 10px 10px 10px"
                                        data-place="right"
                                        data-tip={Constants.BIDS_TOOLTIP}
                                        data-for="projectFollowers"
                                      >
                                        <svg
                                          className="svg-tooltip-icon"
                                          viewBox="0 0 1024 1024"
                                          version="1.1"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                                        </svg>
                                      </p>
                                      <ReactTooltip
                                        className="tooltip"
                                        id="projectFollowers"
                                        delayHide={1000}
                                      >
                                        You will be able to select quotes once
                                        your accounts payable information is
                                        verified by OPAL-Marketing. Verification can
                                        take five business days. To speed up
                                        verification, contact us at{" "}
                                        <a href="mailto:AccountsReceivable@cloudwords.com">
                                          AccountsReceivable@cloudwords.com
                                        </a>{" "}
                                        or 1-415-3994-8012.
                                      </ReactTooltip>
                                    </div>
                                  </div>
                                ) : (
                                  getBidStatus(
                                    iterations.displayName[0],
                                    bid,
                                    iterationIndex
                                  )
                                )
                              ) : (
                                <></>
                              )}
                            </td>
                          </tr>
                          <tr aria-hidden={iterationBidId.includes(bid.id) ? 'false' : 'true'}>
                            <td colSpan="3" className="p-0">
                              <div
                                className={
                                  iterationBidId.includes(bid.id)
                                    ? "breakdown-show show-details"
                                    : "breakdown-show"
                                }
                                id="breakdown-details"
                              >
                                <table key={index} aria-label="Pricing Breakdown">
                                  <thead>
                                    <tr>
                                      <th>Language</th>
                                      {bid.bidItems[0].bidItemTasks.map(
                                        (itemTask, index) => {
                                          if (itemTask.projectTaskType.parentType === "" ||
                                            itemTask.projectTaskType.type === "translation" ) {
                                            return (
                                              <th key={index}>
                                                {
                                                  itemTask.projectTaskType
                                                    .display
                                                }
                                              </th>
                                            );
                                          }
                                        }
                                      )}
                                      <th>Subtotal</th>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    {bid.bidItems.map((item, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <tr>
                                            <td>
                                              <strong>{iterations.displayName[0][bid.vendor.id].bidItems[index].language.display}</strong>
                                            </td>
                                            {item.bidItemTasks.map(
                                              (itemTask, index) => {
                                                if (
                                                  itemTask.projectTaskType
                                                    .type === "translation"
                                                ) {
                                                  return (
                                                    <td key={index}>
                                                      <button
                                                        className={
                                                          item.itemStatus
                                                            ? "breakdown flex-center inner show-main"
                                                            : "breakdown flex-center inner"
                                                        }
                                                        id="sub-breakdown"
                                                        onClick={() =>
                                                          SubbreakdownShow(
                                                            item.id,
                                                            !item.itemStatus      
                                                          )
                                                        }
                                                        aria-expanded={item.itemStatus ? "true" : "false"}
                                                        aria-label={itemTask.cost.display + " details"}
                                                      >
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="20"
                                                          height="20"
                                                          viewBox="0 0 20 20"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M12.8245 7.79075L10.0011 10.6141L7.17781 7.79075L5.87614 9.08325L10.0011 13.2083L14.1261 9.08325L12.8245 7.79075ZM10.0011 0.833252C4.94114 0.833252 0.834473 4.93992 0.834473 9.99992C0.834473 15.0599 4.94114 19.1666 10.0011 19.1666C15.0611 19.1666 19.1678 15.0599 19.1678 9.99992C19.1678 4.93992 15.0611 0.833252 10.0011 0.833252ZM10.0011 17.3333C5.94947 17.3333 2.66781 14.0516 2.66781 9.99992C2.66781 5.94825 5.94947 2.66659 10.0011 2.66659C14.0528 2.66659 17.3345 5.94825 17.3345 9.99992C17.3345 14.0516 14.0528 17.3333 10.0011 17.3333Z"
                                                            fill="#1D4ED8"
                                                          ></path>
                                                        </svg>
                                                        <span className="blue 1">
                                                          {
                                                            itemTask.cost
                                                              .displayWithDecimals
                                                          }
                                                        </span>
                                                      </button>
                                                    </td>
                                                  );
                                                } else if (itemTask.projectTaskType.parentType === '') {
                                                  return (
                                                    <td key={index}>
                                                      {itemTask.cost.displayWithDecimals}
                                                    </td>
                                                  );
                                                }
                                              }
                                            )}
                                            <td>
                                              <strong>
                                                {item.totalBidItemCost.displayWithDecimals}
                                              </strong>
                                            </td>
                                          </tr>
                                          <tr aria-hidden={item.itemStatus ? 'false' : 'true'}>
                                            <td colSpan="5" className="p-0">
                                              <div
                                                className={
                                                  item.itemStatus
                                                    ? "translation-sub-list show-details"
                                                    : "translation-sub-list"
                                                }
                                                id="sub-breakdown-details"
                                              >
                                                {iterations.displayName[0][bid.vendor.id].bidItems[index].tmLeveragingSummary && 
                                                iterations.displayName[0][bid.vendor.id].bidItems[index].tmLeveragingSummary.infoAvailable ? 
                                                <>
                                                <div className="head">
                                                  {iterations.displayName[0][bid.vendor.id].bidItems[index].language.display} Translation
                                                  Memory Leveraging Information
                                                </div>
                                                <div className="list-heading">
                                                  <div></div>
                                                  <div>Number of words</div>
                                                  <div>
                                                    Cost per word
                                                    <div className="gb-tooltip">
                                                      <button aria-label="tooltip">
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          width="16"
                                                          height="16"
                                                          viewBox="0 0 16 16"
                                                          fill="none"
                                                        >
                                                          <path
                                                            d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
                                                            fill="#64748B"
                                                          ></path>
                                                          <path
                                                            d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
                                                            fill="#64748B"
                                                          ></path>
                                                        </svg>
                                                      </button>
                                                      <div className="wrap-tooltip-content" style={{bottom:"10px",width:"450px"}}>
                                                        <div className="triangle"></div>
                                                        <div className="gb-tooltip-content" style={{width:"500px"}}>
                                                          <p>{t('bids.cost_per_word')}</p>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div>Total Cost</div>
                                                </div>
                                                {item.bidItemTasks.map(                                                  

                                                  (itemTask, index) => {                                                                                                        
                                                    if (PriceBreakDownOptions.includes(itemTask.projectTaskType.type)) {
                                                      return (
                                                        <div
                                                          className="list-content"
                                                          key={index}
                                                        >
                                                          <div>
                                                            {itemTaskDisplay[itemTask.projectTaskType.type] ? itemTaskDisplay[itemTask.projectTaskType.type] : itemTask.projectTaskType.display}
                                                          </div>
                                                          <div>
                                                            {itemTask.numWords}
                                                          </div>
                                                          <div>
                                                            {itemTask.costPerWord.displayWithDecimals}
                                                          </div>
                                                          <div>
                                                            {itemTask.cost.displayWithDecimals}
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  }
                                                )}
                                                <div className="list-content list-footer">
                                                  <div>Total</div>
                                                  <div>
                                                    {
                                                      item.tmLeveragingSummary
                                                        .totalWords
                                                    }
                                                  </div>
                                                  <div></div>
                                                  <div>
                                                    {
                                                      item.tmLeveragingSummary
                                                        .totalCost.displayWithDecimals
                                                    }
                                                  </div>
                                                </div>
                                                </>  : 
                                                <div className="head">
                                                No translation memory leveraging information is available for {" "}{iterations.displayName[0][bid.vendor.id].bidItems[index].language.display}
                                              </div> }

                                              </div>
                                            </td>
                                          </tr>
                                        </React.Fragment>
                                      );
                                    })}
                                    <tr>
                                      <td>Subtotal</td>
                                      {bid.bidTaskSubtotals.map(
                                        (subTotal, index) => {
                                          if (
                                            subTotal.taskType.type ===
                                            "translation"
                                          ) {
                                            return (
                                              <td className="p-54" key={index}>
                                                {subTotal.subtotal.displayWithDecimals}
                                              </td>
                                            );
                                          }
                                          if (subTotal.taskType.parentType === '' ) {
                                            return (
                                              <td key={index}>
                                                {subTotal.taskType.type !== 'commission' ? subTotal.subtotal.displayWithDecimals : ''}
                                              </td>
                                            );
                                          }
                                        }
                                      )}
                                    </tr>
                                    <tr>
                                      <td colSpan="4">
                                      All prices are in {projectDisplay.currency.code} ({projectDisplay.currency?.pluralLabel})
                                      </td>
                                      <td colSpan="6">
                                        Quote Subtotal:{" "}
                                        {bid.preDiscountBidCost.display}
                                      </td>
                                    </tr>
                                    {iterations.resource.bids[index].bidDiscount.amount > 0 ?
                                     <tr>
                                     <td colSpan="4">
                                       Discount offered by the vendor:{" "}
                                       {iterations.resource.bids[index].bidDiscount.amount}
                                       %
                                     </td>
                                     <td colSpan="6">
                                       Discount :
                                       {projectDisplay.currency?.symbol} {(
                                         iterations.resource.bids[index]
                                           .preDiscountBidCost.value -
                                         iterations.resource.bids[index]
                                           .totalBidCost.value
                                       ).toFixed(2)}
                                     </td>
                                   </tr> : ''}
                                    <tr>
                                    {iterations.resource.bids[index].bidDiscount.amount > 0 ?
                                      <td colSpan="8">
                                        <div className="footer-first flex-center flex">
                                          <p className="italic">
                                          All prices are in {projectDisplay.currency.code} ({projectDisplay.currency?.pluralLabel})
                                          </p>
                                          <p
                                            className="total"
                                          >
                                            Quote total:{" "}
                                            <strong>
                                              {
                                                iterations.resource.bids[index]
                                                  .totalBidCost.display
                                              }
                                            </strong>
                                          </p>
                                        </div>
                                      </td>:""}
                                    </tr>
                                  </tbody>
                                </table>

                                {iterations.resource.bids[0].description !== "" ? (
                                  <div className="footer-second">
                                    <strong>Quote Description: </strong>
                                    <p dangerouslySetInnerHTML={{__html: ConvertNewLineToBr(iterations.resource.bids[0].description)}}></p>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {projectStatus.code ===
                                "in_cancellation_waiting_for_customer" ? (
                                  <div className="modal-footer flex btn-gap">
                                    <div>
                                      <button
                                        className="btn btn-bold"
                                        onClick={hideModel}
                                      >
                                        Accept
                                      </button>
                                      <button
                                        className="btn btn-bold"
                                        onClick={hideModel}
                                      >
                                        Reject
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })
                  )}
                </tbody>
              );
            })}
          </table>
        </div>
      ) : projectStatus.code === "cancelled" ||
        projectStatus.code === "in_cancellation_waiting_for_customer" ? (
        Object.keys(cancelItteration).length !== 0 ? (
          <div className="relative breakdown-show show-details" style={{display:"block"}}>
            <table className=" relative 2">
              <thead>
                <tr className="cancelTh">
                  <th>Language</th>
                  {cancelItteration.resource.bidItems[0].bidItemTasks.map(
                    (bid, index) => {
                      if (bid.projectTaskType.parentType === '') {
                        return (
                          <th
                            key={index}
                            style={
                              bid.projectTaskType.type !== "translation" 
                                ? { width: "16%",paddingLeft:"14px" }
                                : {}
                            }
                          >
                            {bid.projectTaskType.display === "Desktop Publishing" ? "DTP" : bid.projectTaskType.display}
                          </th>
                        );
                      }
                    }
                  )}
                  <th><span>Total </span>
                  <p
                    style={{position:"absolute",right:"70px",top:"16px"}}
                    tabindex={0}
                    data-events={["focus"]}
                    data-eventsoff={["blur"]}
                    data-padding="10px 10px 10px 10px"
                    data-place="right"
                    data-tip={Constants.BIDS_TOOLTIP}
                    data-for="totalCost"
                  >
                    <svg
                      className="svg-tooltip-icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                    </svg>
                  </p>
                  <ReactTooltip
                    className="tooltip"
                    id="totalCost"
                    delayHide={1000}
                  >
                    <h4>Total</h4>
                    Includes charge for use of the OPAL-Marketing Platform
                  </ReactTooltip>
                  </th>
                </tr>
              </thead>
              <tbody className="cancelTbody">
                <>
                  {cancelItteration.resource.bidItems.map(
                    (bidItem, bidItemIndex) => {
                      return bidItem.bidItemTasks.map((bid, index) => {
                        if (bid.projectTaskType.parentType === '') {
                          if (bid.projectTaskType.type === "translation") {
                            return (
                              <tr key={index} id="innerTr">
                                <td id="outermost" colSpan="12" className="p-0">
                                  <div className=" main" id="breakdown-details">
                                    
                                    <table key={index}>
                                      <tbody>
                                        <tr className="innerOne" >
                                          <td className="inside">
                                            {
                                              cancelItteration.displayName[0]
                                                .bidItems[bidItemIndex].language
                                                .display
                                            }
                                          </td>
                                          {bidItem.bidItemTasks.map(
                                            (itemTask, index) => {
                                              if (
                                                itemTask.projectTaskType
                                                  .type === "translation"
                                              ) {
                                                return (
                                                  <td
                                                    key={index}
                                                    className="inside"
                                                  >
                                                    <button
                                                      className={
                                                        bidItem.itemStatus
                                                          ? "breakdown flex-center inner show-main"
                                                          : "breakdown flex-center inner"
                                                      }
                                                      id="sub-breakdown"
                                                      onClick={() =>
                                                        SubbreakdownShow(
                                                          bidItem.id,
                                                            !bidItem.itemStatus
                                                        )
                                                      }
                                                      aria-expanded={bidItem.itemStatus ? "true" : "false"}
                                                      aria-label={bidItem.tmLeveragingSummary.totalCost.displayWithDecimals + " details"}
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M12.8245 7.79075L10.0011 10.6141L7.17781 7.79075L5.87614 9.08325L10.0011 13.2083L14.1261 9.08325L12.8245 7.79075ZM10.0011 0.833252C4.94114 0.833252 0.834473 4.93992 0.834473 9.99992C0.834473 15.0599 4.94114 19.1666 10.0011 19.1666C15.0611 19.1666 19.1678 15.0599 19.1678 9.99992C19.1678 4.93992 15.0611 0.833252 10.0011 0.833252ZM10.0011 17.3333C5.94947 17.3333 2.66781 14.0516 2.66781 9.99992C2.66781 5.94825 5.94947 2.66659 10.0011 2.66659C14.0528 2.66659 17.3345 5.94825 17.3345 9.99992C17.3345 14.0516 14.0528 17.3333 10.0011 17.3333Z"
                                                          fill="#1D4ED8"
                                                        ></path>
                                                      </svg>
                                                      <span
                                                        className="blue"
                                                        style={{
                                                          margin: "0 9px",width:"16.66%"
                                                        }}
                                                      >
                                                        {
                                                          bidItem.tmLeveragingSummary.totalCost.displayWithDecimals
                                                        }
                                                      </span>
                                                    </button>
                                                  </td>
                                                );
                                              } else if (itemTask.projectTaskType.parentType === '') {
                                                return (
                                                  <td
                                                    style={{ width: "16%" }}
                                                    key={index}
                                                    id={
                                                      itemTask.projectTaskType
                                                        .type
                                                    }
                                                  >
                                                    {
                                                      itemTask.cost
                                                        .displayWithDecimals
                                                    }
                                                  </td>
                                                );
                                              }
                                            }
                                          )}
                                          <td>
                                            <strong>
                                              {
                                                bidItem.totalBidItemCost
                                                  .displayWithDecimals
                                              }
                                            </strong>
                                          </td>
                                        </tr>
                                        <tr id="inner2">
                                          <td colSpan="5" className="p-0">
                                            <div
                                              className={
                                                bidItem.itemStatus
                                                  ? "translation-sub-list show-details"
                                                  : "translation-sub-list "
                                              }
                                              id="sub-breakdown-details"
                                            >
                                              <div className="head">
                                                {cancelItteration.displayName[0]
                                                .bidItems[bidItemIndex].language
                                                .display} Translation Memory
                                                Leveraging Information
                                              </div>
                                              <div className="list-heading">
                                                <div></div>
                                                <div>Number of words</div>
                                                <div>
                                                  Cost per word
                                                  <div className="gb-tooltip">
                                                    <button aria-label="tooltip">
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="16"
                                                        height="16"
                                                        viewBox="0 0 16 16"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
                                                          fill="#64748B"
                                                        ></path>
                                                        <path
                                                          d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
                                                          fill="#64748B"
                                                        ></path>
                                                      </svg>
                                                    </button>
                                                    <div className="wrap-tooltip-content" style={{bottom:"10px",width:"450px"}}>
                                                      <div className="triangle"></div>
                                                      <div className="gb-tooltip-content" style={{width:"500px"}}>
                                                      <p>{t('bids.cost_per_word')}</p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div>Total Cost</div>
                                              </div>
                                              {bidItem.bidItemTasks.map(
                                                (itemTask, index) => {
                                                  if (PriceBreakDownOptions.includes(itemTask.projectTaskType.type)) {
                                                    return (
                                                      <div
                                                        className="list-content"
                                                        key={index}
                                                      >
                                                        <div>
                                                          {itemTask.projectTaskType.display}
                                                        </div>
                                                        <div>
                                                          {itemTask.numWords}
                                                        </div>
                                                        <div>
                                                          {itemTask.costPerWord.displayWithDecimals}
                                                        </div>
                                                        <div>
                                                          {itemTask.cost.displayWithDecimals}
                                                        </div>
                                                      </div>
                                                    );
                                                  }
                                                }
                                              )}
                                              <div className="list-content list-footer">
                                                <div>Total</div>
                                                <div>
                                                  {
                                                    bidItem.tmLeveragingSummary
                                                      .totalWords
                                                  }
                                                </div>
                                                <div></div>
                                                <div>
                                                  $
                                                  {
                                                    bidItem.tmLeveragingSummary
                                                      .totalCost.value
                                                  }
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    {/* );
                                    }
                                  )} */}
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                          //  else {
                          //   return (
                          //     <td key={index} id="outside">
                          //       {bid.cost.displayWithFourDecimals}
                          //     </td>
                          //   );
                          // }
                        }
                      });
                    }
                  )}

                  <tr id="outertr">
                    <td>Subtotal</td>
                    {cancelItteration.displayName[0].bidTaskSubtotals.map(
                      (subtotal, index) => {
                        if (subtotal.taskType.parentType === '') {
                          return (
                            <td key={index} style={
                              subtotal.taskType.type === "DESKTOP_PUBLISHING" ? {width:'15%',paddingLeft:"15px"}:
                              subtotal.taskType.type === "PROJECT_MANAGEMENT" ? { width: "15%",paddingLeft:"20px" }:
                              subtotal.taskType.type === "REVIEW" ? {textAlign:"left"} : { width: "15%" }}>
                              {subtotal.subtotal.displayWithFourDecimals}
                            </td>
                          );
                        }
                      }
                    )}
                  </tr>
                  {cancelItteration.resource.bidDiscount.amount > 0 ? (
                    <>
                      <tr className="innerOne">
                        <td
                          colSpan={6}
                        >
                          <strong className="error text-right">
                            Quote Subtotal:{" "}
                            {
                              cancelItteration.displayName[0].preDiscountBidCost
                                .displayWithFourDecimals
                            }
                          </strong>
                        </td>
                      </tr>
                      <tr className="innerOne">
                        <td
                          colSpan={6}>
                          <strong className="error text-right">
                            Discount (
                            {cancelItteration.resource.bidDiscount.amount}%) :
                            (${" "}
                            {(
                              cancelItteration.displayName[0].preDiscountBidCost
                                .value -
                              cancelItteration.displayName[0].totalBidCost.value
                            ).toFixed(2)}
                            )
                          </strong>
                        </td>
                      </tr>
                    </>
                  ) : (
                    ""
                  )}
                  <tr className="innerOne">
                    <td
                      colSpan={6}
                    >
                      <strong className="error text-right">
                        Updated Quote Total{" "}
                        {
                          cancelItteration.displayName[0].totalBidCost
                            .displayWithFourDecimals
                        }
                      </strong>
                    </td>
                  </tr>
                </>
              </tbody>
            </table>
            {cancelItteration.resource.description !== "" ? (
              <div className="footer-second mar-bot20">
                <strong>Final Charges Quote Description:</strong>
                <p dangerouslySetInnerHTML={{__html:ConvertNewLineToBr(cancelItteration.resource.description)}}></p>
              </div>
            ) : (
              ""
            )}
            {projectStatus.code === "in_cancellation_waiting_for_customer" ? (
              <div
                className="modal-footer flex btn-gap justify-end"
                style={{ marginBottom: "50px" }}
              >
                <div className="flex  btn-gap">
                  <button className="btn btn-bold" onClick={confirmBidAccept}>
                    Accept
                  </button>
                  <button className="btn btn-bold" onClick={rejectBid}>
                    Reject
                  </button>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )
      ) : projectStatus.code === "in_cancellation_waiting_for_vendor" ? 
        <div className="source-header flex-center source-file">
          <div className="bids-table">
            <ul>
              <li>
                <p>
                  You have requested to cancel this project. You will be
                  notified by email when the vendor has updated the quote with
                  charges for the work completed.
                </p>
              </li>
            </ul>
          </div>
        </div> : ''
      }
      {historyItteration.length > 0 ? (
        <>
          <div className="source-header flex-center source-file">
            <h4>Quote History</h4>
          </div>
          <div className="relative table-responsive">
            <table className="bids-table-list relative 3">
              <thead>
                <tr>
                  <th>Vendor</th>
                  <th>Total</th>
                  <th>Quote Status</th>
                </tr>
              </thead>
              {historyItteration.map((iterations, index) => {
                return (
                  <tbody key={index}>
                     <tr>
                     <td colSpan={6} className="quote-requested">
                     {
                     iterations.resource.bids[0].changeOrder !== '' ?
                       <div>
                        <Link onClick={(e)=>redirectChangeOrder(e,iterations.resource.bids[0].changeOrder)}>Change order</Link> Quote Requested: {utcDateTimeWithTimeZoneWithFormat(iterations.resource.bids[0].changeOrder.createdDate,
                         Constants.DATE_FORMAT_MM_DD_YYYY_HH_MM_SS,
                         custBootstrapDataRedux?.user?.timeZone
                       )}</div> : 
                       <div>Quote Requested: {iterations.resource.startDate.dateWithTime}</div>
                     }
                     </td>
                   </tr>
                    {!iterations.displayName.bidDetailsViewableByCustomer &&
                    iterations.displayName.pendingVendorApproval ? (
                      <tr>
                        <td>
                          <span
                            className="blue head"
                            role="button"
                            aria-label={
                              iterations.resource.bids[index].vendor?.name
                            }
                            tabIndex="0"
                          >
                            {iterations.resource.bids[index].vendor?.name}
                          </span>
                        </td>
                        
                        <td>
                          <button className="not-submit">
                            {iterations.status.display}
                          </button>
                        </td>
                      </tr>
                    ) : (
                      iterations.resource.bids.map((bid, ind) => {
                        return (
                          <React.Fragment key={ind}>
                            <tr>
                              <td>
                                <span
                                  className="blue head"
                                  role="button"
                                  aria-label={bid?.vendor?.name}
                                  tabIndex="0"
                                >
                                  {bid?.vendor?.name}
                                </span>
                                {getBidDetailsViewableByCustomer(
                                  iterations,
                                  ind
                                ) ? (
                                  <button
                                    className={
                                      bid?.id === iterationBidId
                                        ? "breakdown flex-center show-main"
                                        : "breakdown flex-center"
                                    }
                                    onClick={() => breakdownShow(bid?.id)}
                                    tabIndex="0"
                                    aria-expanded={bid?.id === iterationBidId ? "true" : "false"}
                                    aria-label="Pricing Breakdown"
                                  >
                                    <span>Pricing Breakdown</span>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                    >
                                      <path
                                        d="M12.8245 7.79075L10.0011 10.6141L7.17781 7.79075L5.87614 9.08325L10.0011 13.2083L14.1261 9.08325L12.8245 7.79075ZM10.0011 0.833252C4.94114 0.833252 0.834473 4.93992 0.834473 9.99992C0.834473 15.0599 4.94114 19.1666 10.0011 19.1666C15.0611 19.1666 19.1678 15.0599 19.1678 9.99992C19.1678 4.93992 15.0611 0.833252 10.0011 0.833252ZM10.0011 17.3333C5.94947 17.3333 2.66781 14.0516 2.66781 9.99992C2.66781 5.94825 5.94947 2.66659 10.0011 2.66659C14.0528 2.66659 17.3345 5.94825 17.3345 9.99992C17.3345 14.0516 14.0528 17.3333 10.0011 17.3333Z"
                                        fill="#1D4ED8"
                                      />
                                    </svg>
                                  </button>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>
                                <div className="dollar">
                                  {bid.totalBidCost?.display}
                                </div>
                              </td>
                              <td>
                                {options.features !== undefined ? (
                                  !(
                                    options?.features?.STRIPE &&
                                    stripeUserPreference === "true"
                                  ) &&
                                  !options?.accountStatus?.verified &&
                                  getBidStatus(
                                    iterations.displayName[0],
                                    bid,
                                    index
                                  ) ? (
                                    <div>
                                      <div className="tooltip-container bids-tooltip">
                                        <p>Submitted</p>
                                        <p
                                          tabindex={0}
                                          data-events={["focus"]}
                                          data-eventsoff={["blur"]}
                                          data-padding="10px 10px 10px 10px"
                                          data-place="right"
                                          data-tip={Constants.BIDS_TOOLTIP}
                                          data-for="projectFollowers"
                                        >
                                          <svg
                                            className="svg-tooltip-icon"
                                            viewBox="0 0 1024 1024"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                                          </svg>
                                        </p>
                                        <ReactTooltip
                                          className="tooltip"
                                          id="projectFollowers"
                                          delayHide={1000}
                                        >
                                          You will be able to select quotes once
                                          your accounts payable information is
                                          verified by OPAL-Marketing. Verification
                                          can take five business days. To speed
                                          up verification, contact us at{" "}
                                          <a href="mailto:AccountsReceivable@cloudwords.com">
                                            AccountsReceivable@cloudwords.com
                                          </a>{" "}
                                          or 1-415-3994-8012.
                                        </ReactTooltip>
                                      </div>
                                    </div>
                                  ) : (
                                    getBidStatus(
                                      iterations.displayName[0],
                                      bid,
                                      index
                                    )
                                  )
                                ) : (
                                  <></>
                                )}
                              </td>
                            </tr>
                            <tr aria-hidden={bid.id === iterationBidId ? 'false' : 'true'}>
                              <td colSpan="3" className="p-0">
                                <div
                                  className={
                                    bid.id === iterationBidId
                                      ? "breakdown-show show-details"
                                      : "breakdown-show"
                                  }
                                  id="breakdown-details"
                                  aria-label="Pricing Breakdown"
                                >
                                  {/* {bid.bidItems.map(
                                (item, bidItemIndex) => {
                                  return ( */}
                                  <table key={index}>
                                    <thead>
                                      {/* {bid.bidItems.map(
                                (item, bidItemIndex) => {
                                  return ( */}
                                      <tr>
                                        <th>Language</th>
                                        {bid.bidItems[0].bidItemTasks.map(
                                          (itemTask, index) => {
                                            if (itemTask.projectTaskType.parentType === '' ||
                                            itemTask.projectTaskType.type === "translation") {
                                              return (
                                                <th key={index}>
                                                  {
                                                    itemTask.projectTaskType
                                                      .display
                                                  }
                                                </th>
                                              );
                                            }
                                          }
                                        )}
                                        <th>Subtotal</th>
                                      </tr>
                                      {/* );
  }
)} */}
                                    </thead>
                                    <tbody>
                                      {bid.bidItems.map(
                                        (item, bidItemIndex) => {
                                          return (
                                            <React.Fragment key={bidItemIndex}>
                                              <tr>
                                                <td>
                                                  <strong>
                                                    {iterations.displayName[0][bid.vendor.id].bidItems[bidItemIndex].language.display}
                                                  </strong>
                                                </td>
                                                {item.bidItemTasks.map(
                                                  (itemTask, index) => {
                                                    if (
                                                      itemTask.projectTaskType
                                                        .type === "translation"
                                                    ) {
                                                      return (
                                                        <td key={index}>
                                                          <button
                                                            className={
                                                              item.itemStatus
                                                                ? "breakdown flex-center inner show-main"
                                                                : "breakdown flex-center inner"
                                                            }
                                                            id="sub-breakdown"
                                                            onClick={() =>
                                                              SubbreakdownShow(
                                                                item.id,
                                                                !item.itemStatus
                                                              )
                                                            }
                                                            aria-expanded={item.id === bidItemId ? "true" : "false"}
                                                            aria-label={item.tmLeveragingSummary.totalCost.displayWithDecimals + " details"}
                                                          >
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width="20"
                                                              height="20"
                                                              viewBox="0 0 20 20"
                                                              fill="none"
                                                            >
                                                              <path
                                                                d="M12.8245 7.79075L10.0011 10.6141L7.17781 7.79075L5.87614 9.08325L10.0011 13.2083L14.1261 9.08325L12.8245 7.79075ZM10.0011 0.833252C4.94114 0.833252 0.834473 4.93992 0.834473 9.99992C0.834473 15.0599 4.94114 19.1666 10.0011 19.1666C15.0611 19.1666 19.1678 15.0599 19.1678 9.99992C19.1678 4.93992 15.0611 0.833252 10.0011 0.833252ZM10.0011 17.3333C5.94947 17.3333 2.66781 14.0516 2.66781 9.99992C2.66781 5.94825 5.94947 2.66659 10.0011 2.66659C14.0528 2.66659 17.3345 5.94825 17.3345 9.99992C17.3345 14.0516 14.0528 17.3333 10.0011 17.3333Z"
                                                                fill="#1D4ED8"
                                                              ></path>
                                                            </svg>
                                                            <span className="blue">
                                                              {
                                                                item
                                                                  .tmLeveragingSummary
                                                                  .totalCost
                                                                  .displayWithDecimals
                                                              }
                                                            </span>
                                                          </button>
                                                        </td>
                                                      );
                                                    } else if (
                                                      itemTask.projectTaskType.parentType === '') {
                                                      return (
                                                        <td key={index}>
                                                          {
                                                            itemTask.cost
                                                              .displayWithDecimals
                                                          }
                                                        </td>
                                                      );
                                                    }
                                                  }
                                                )}
                                                <td>
                                                  <strong>
                                                    {
                                                      item.totalBidItemCost
                                                        .displayWithDecimals
                                                    }
                                                  </strong>
                                                </td>
                                              </tr>
                                              <tr aria-hidden={item.itemStatus ? 'false' : 'true'}>
                                                <td colSpan="5" className="p-0">
                                                  <div
                                                    className={
                                                      item.itemStatus
                                                        ? "translation-sub-list show-details"
                                                        : "translation-sub-list"
                                                    }
                                                    id="sub-breakdown-details"
                                                  >
                                                    {iterations.displayName[0][bid.vendor.id].bidItems[bidItemIndex].tmLeveragingSummary && 
                                                    iterations.displayName[0][bid.vendor.id].bidItems[bidItemIndex].tmLeveragingSummary.infoAvailable ? 
                                                     <> 
                                                    <div className="head">
                                                    {iterations.displayName[0][bid.vendor.id].bidItems[bidItemIndex].language.display} Translation Memory
                                                      Leveraging Information
                                                    </div>
                                                    <div className="list-heading">
                                                      <div></div>
                                                      <div>Number of words</div>
                                                      <div>
                                                        Cost per word
                                                        <div className="gb-tooltip">
                                                          <button aria-label="tooltip">
                                                            <svg
                                                              xmlns="http://www.w3.org/2000/svg"
                                                              width="16"
                                                              height="16"
                                                              viewBox="0 0 16 16"
                                                              fill="none"
                                                            >
                                                              <path
                                                                d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z"
                                                                fill="#64748B"
                                                              ></path>
                                                              <path
                                                                d="M8.92995 6.588L6.63995 6.875L6.55795 7.255L7.00795 7.338C7.30195 7.408 7.35995 7.514 7.29595 7.807L6.55795 11.275C6.36395 12.172 6.66295 12.594 7.36595 12.594C7.91095 12.594 8.54395 12.342 8.83095 11.996L8.91895 11.58C8.71895 11.756 8.42695 11.826 8.23295 11.826C7.95795 11.826 7.85795 11.633 7.92895 11.293L8.92995 6.588ZM8.99995 4.5C8.99995 4.76522 8.8946 5.01957 8.70706 5.20711C8.51952 5.39464 8.26517 5.5 7.99995 5.5C7.73474 5.5 7.48038 5.39464 7.29285 5.20711C7.10531 5.01957 6.99995 4.76522 6.99995 4.5C6.99995 4.23478 7.10531 3.98043 7.29285 3.79289C7.48038 3.60536 7.73474 3.5 7.99995 3.5C8.26517 3.5 8.51952 3.60536 8.70706 3.79289C8.8946 3.98043 8.99995 4.23478 8.99995 4.5Z"
                                                                fill="#64748B"
                                                              ></path>
                                                            </svg>
                                                          </button>
                                                          <div className="wrap-tooltip-content" style={{bottom:"10px",width:"450px"}}>
                                                            <div className="triangle"></div>
                                                            <div className="gb-tooltip-content">
                                                            <p>{t('bids.cost_per_word')}</p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div>Total Cost</div>
                                                    </div>
                                                    {item.bidItemTasks.map(
                                                      (itemTask, index) => {
                                                        if (
                                                          itemTask
                                                            .projectTaskType
                                                            .type ===
                                                            "translation_translated_words" ||
                                                          itemTask
                                                            .projectTaskType
                                                            .type ===
                                                            "translation_repeated_words" ||
                                                          itemTask
                                                            .projectTaskType
                                                            .type ===
                                                            "translation_fuzzy_match_words" ||
                                                          itemTask
                                                            .projectTaskType
                                                            .type ===
                                                            "translation_new_words"
                                                        ) {
                                                          return (
                                                            <div
                                                              className="list-content"
                                                              key={index}
                                                            >
                                                              <div>
                                                                {
                                                                  itemTask
                                                                    .projectTaskType
                                                                    .display
                                                                }
                                                              </div>
                                                              <div>
                                                                {
                                                                  itemTask.numWords
                                                                }
                                                              </div>
                                                              <div>
                                                                {itemTask.costPerWord.displayWithDecimals}
                                                              </div>
                                                              <div>
                                                                {
                                                                  itemTask.cost
                                                                    .displayWithDecimals
                                                                }
                                                              </div>
                                                            </div>
                                                          );
                                                        }
                                                      }
                                                    )}
                                                    <div className="list-content list-footer">
                                                      <div>Total</div>
                                                      <div>
                                                        {
                                                          item
                                                            .tmLeveragingSummary
                                                            .totalWords
                                                        }
                                                      </div>
                                                      <div></div>
                                                      <div>
                                                        {
                                                          item
                                                            .tmLeveragingSummary
                                                            .totalCost.displayWithDecimals
                                                        }
                                                      </div>
                                                    </div>
                                                    </> : 
                                                    <div className="head">
                                                    No translation memory leveraging information is available forDutch for {" "}{iterations.displayName[0][bid.vendor.id].bidItems[bidItemIndex].language.display}
                                                    </div>
                                                    }
                                                  </div>
                                                </td>
                                              </tr>
                                            </React.Fragment>
                                          );
                                        }
                                      )}

                                      <tr>
                                        <td>Subtotal</td>
                                        {bid.bidTaskSubtotals.map(
                                          (subTotal, index) => {
                                            if (
                                              subTotal.taskType.type === "translation"
                                            ) {
                                              return (
                                                <td
                                                  className="p-54"
                                                  key={index}
                                                >
                                                  {subTotal.subtotal.displayWithDecimals}
                                                </td>
                                              );
                                            }
                                            
                                            if (subTotal.taskType.parentType === '' && subTotal.taskType.type !== "translation") {
                                              return (
                                                <td key={index}>
                                                  {subTotal.subtotal.displayWithDecimals}
                                                </td>
                                              );
                                            }
                                          }
                                        )}

                                        <td></td>
                                      </tr>
                                      <tr>
                                        <td colSpan="3">
                                        All prices are in {projectDisplay.currency.code} ({projectDisplay.currency?.pluralLabel})
                                        </td>
                                        <td colSpan="3">
                                          <strong>Quote Subtotal</strong> :{" "}
                                          {
                                            bid.preDiscountBidCost
                                              .displayWithDecimals
                                          }
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colSpan="3">
                                          Discount offered by the vendor:{" "}
                                          <strong>
                                            {bid.bidDiscount.amount}%
                                          </strong>
                                        </td>
                                        <td colSpan="3">
                                          <strong>Discount</strong> : $
                                          {(
                                            bid.preDiscountBidCost.value -
                                            bid.totalBidCost.value
                                          ).toFixed(2)}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colSpan="6">
                                          <div className="footer-first flex-center flex">
                                            <p className="italic">
                                            All prices are in {projectDisplay.currency.code} ({projectDisplay.currency?.pluralLabel})
                                            </p>
                                            <p
                                              className="total"
                                            >
                                              Quote total:{" "}
                                              <strong>
                                                {
                                                  bid.totalBidCost
                                                    .displayWithDecimals
                                                }
                                              </strong>
                                            </p>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/* );
                                }
                              )} */}
                                  {bid.description !== "" ? (
                                    <div className="footer-second">
                                      <strong>Quote Description:</strong>
                                      <p dangerouslySetInnerHTML={{__html:ConvertNewLineToBr(bid.description)}}></p>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })
                    )}
                  </tbody>
                );
              })}
            </table>
          </div>
        </>
      ) : (
        ""
      )}
      {!(showBidSelectionPopup || POSelectionPopup) ? (
        showAcctsPayablePopup ? (
          <div id="modelPopup" className="lightbox-panel">
            <div className="inner-lightbox-panel pb-0">
              <div className="modal-header flex padd-lr">
                {acctsPayableVerificationNote ? (
                  <strong>Accounts Payable Verification in Process</strong>
                ) : (
                  <strong>Accounts Payable Information</strong>
                )}
              </div>
              <div className="lightbox-content padd-22 vender-form-block overflow-inherit">
                {acctsPayableVerificationNote ? (
                  <div className="vender-form-block">
                    The OPAL-Marketing Team will verify your Accounts Payable
                    information within five business days.
                  </div>
                ) : (
                  <div className="profile-editonly-block">
                    <div className="profile-edit-form mar-bot14">
                      <div className="mar-bot14">
                        Verification of your accounts payable information may
                        take up to five days. If five days is too long, email us
                        at{" "}
                        <a href="mailto:AccountsReceivable@cloudwords.com">
                          AccountsReceivable@cloudwords.com
                        </a>{" "}
                        or call +1‑415‑394‑8012.
                      </div>
                      <div className="flex wrap-dropdown">
                        <div className="global-dropdown-block flex-center">
                          <label>Accounts Payable Contact Name</label>
                          <input
                            type="text"
                            className="form-control-sm"
                            id="apc-name"
                            title="Accounts Payable Contact Name"
                            onChange={(event) => handleAPInfo(event)}
                          />
                          <div
                            className={
                              "error-alert upload-error" +
                              (apNameError === true ? " show" : " hide")
                            }
                          >
                            {apNameErrorMsg}
                          </div>
                        </div>
                        <div className="global-dropdown-block flex-center">
                          <label>Accounts Payable Email</label>
                          <input
                            type="email"
                            className="form-control-sm"
                            id="apc-email"
                            title="Accounts Payable Contact Email"
                            onChange={(event) => handleAPInfo(event)}
                          />
                          <div
                            className={
                              "error-alert upload-error" +
                              (apEmailError === true ? " show" : " hide")
                            }
                          >
                            {apEmailErrorMsg}
                          </div>
                        </div>
                        <div className="global-dropdown-block flex-center">
                          <label>Accounts Payable Phone</label>
                          <input
                            type="text"
                            className="form-control-sm"
                            id="apc-phone"
                            title="Accounts Payable Contact Phone"
                            onChange={(event) => handleAPInfo(event)}
                          />
                          <div
                            className={
                              "error-alert upload-error" +
                              (apPhoneError === true ? " show" : " hide")
                            }
                          >
                            {apPhoneErrorMsg}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer modal-footer-border flex px-22">
                {acctsPayableVerificationNote ? (
                  <button className="btn btn-bold active" onClick={hideModel}>
                    Close
                  </button>
                ) : (
                  <>
                    <button className="btn btn-bold" onClick={handleEnter}>
                      Enter
                    </button>
                    <button
                      className="btn btn-bold"
                      onClick={handleAcctsPayableNoteCancel}
                    >
                      Cancel
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        ) : project.bidDueDate !== undefined && checkDateExpired(prop.projectDetail.bidDueDate, Constants.DATE_FORMAT_MM_DD_YY_HYPHEN) &&toggleVendorDateModal ? (
            <EditProjectDateBid 
            projectResource={project} 
            keydown={escapeModal}
            projectStatus={projectDetailStatus} 
            close={hideDateVendorModel} 
            preferVendor={preferedVendors}
            autoSelect={allowAutomaticSelect}
            refresh={prop.refresh}
            />
        ) : (
          <BidNeedMoreTime showPopup={showBidUpdatePopup} refresh={prop.refresh} projectDetail={prop.projectDetail}/>
        )
      ) :
      (showBidSelectionPopup || POSelectionPopup) ?  (

        <div id="modelPopup" className="lightbox-panel"
        aria-labelledby={
          POSelectionPopup?'POSelectionPopup'
          :showBack?'showBack'
          :bidSelectionConfirmation?'bidSelectionConfirmation'
          :paymentOptions?'paymentOptions'
          :thankyouNote?'thankyouNote'
          :acctsPayableVerificationNote?'acctsPayableVerificationNote'
          :''} aria-modal="true" role="dialog"
        onKeyDown={(e)=>paymentPopup(e)}
          >
          <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              {POSelectionPopup && <strong id="POSelectionPopup">Select a purchase order</strong>}
              {showBack && <strong id="showBack">Review Order Details</strong>}
              {bidSelectionConfirmation && (
                <strong id="bidSelectionConfirmation">Confirm Quote Selection</strong>
              )}
              {paymentOptions && <strong id="paymentOptions">Payment Methods</strong>}
              {thankyouNote && <strong id="thankyouNote">Thank you for your purchase</strong>}
              {acctsPayableVerificationNote && (
                <strong id="acctsPayableVerificationNote">Accounts Payable Verification in Process</strong>
              )}
            </div>
            <div className="lightbox-content padd-22 vender-form-block overflow-inherit">
              {POSelectionPopup && (
                <div>
                  <span
                    role="button"
                    aria-label="error"
                    className="alert-icon mar-bot14"
                    tabIndex="0"
                  >
                    This project requires a Purchase Order before a quote can be
                    selected.
                  </span>
                  <div className="flex wrap-dropdown m-0">
                    <div className="global-dropdown-block flex-center mar-bot14">
                      <label>Purchase Order Number </label>
                      <div className="global-dropdown-select">
                        <Select
                          className="global-dropdown-select"
                          classNamePrefix="cw"
                          value={customerPurchaseOrder.filter(function (
                            option
                          ) {
                            return option?.value.id === selectedPO.id;
                          })}
                          options={customerPurchaseOrder}
                          aria-label="Purchase Order Number"
                          onChange={(e) => setCustomerPO(e)}
                          menuShouldScrollIntoView={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {paymentOptions &&
                (options?.accountStatus?.verified ? (
                  <div className="group-radio-list" role="radiogroup" aria-labelledby="group_label_1">
                    <p id="group_label_1">
                      Please select the payment method you would like to use for
                      this quote.
                    </p>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        checked={showAccountsPayableInfo}
                        className="form-check-input"
                        name="radio"
                        id="accounts-payable"
                        onChange={(event) => handleAccountsPayable(event)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="accounts-payable"
                      >
                        Accounts Payable
                      </label>
                      {showAccountsPayableInfo ? (
                        <p className="payment-para">
                          OPAL-Marketing will invoice your accounts payable
                          department.
                        </p>
                      ) : options?.accountStatus?.verified ? (
                        <></>
                      ) : (
                        <p>
                          Your account has not been verified yet.{" "}
                          {(customerData?.brand).toUpperCase()} will verify your
                          information within five business days from your
                          submission. If you feel this is an error, please
                          contact{" "}
                          <a href="mailto:AccountsReceivable@cloudwords.com">
                            AccountsReceivable@cloudwords.com
                          </a>{" "}
                          Or call: +1‑415‑394‑8012.
                        </p>
                      )}
                    </div>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        checked={stripeSelected}
                        className="form-check-input"
                        name="radio"
                        id="stripe"
                        onChange={(event) => handleStripe(event)}
                      />
                      <label className="form-check-label" htmlFor="stripe">
                        Credit Card
                      </label>
                      {stripeSelectBidData?.aboveLimit && exceedLimitError ? (
                        <p className="error-alert">
                          This quote exceeds the limit of{" "}
                          {stripeSelectBidData?.limit?.displayWithDecimals} for
                          quotes paid by credit card. If you would like to pay by card, email us at <a href="mailto:AccountsReceivable@cloudwords.com">AccountsReceivable@cloudwords.com</a> or call +1-415-394-8012.
                        </p>
                      ) : <></>}
                      {showStripeForm ? (
                        <div>
                          <p className="payment-para">
                            Maximum charges for translation projects on this
                            account is{" "}
                            {stripeSelectBidData?.limit?.displayWithDecimals}. A
                            3.25% fee for credit card handling will be added to
                            your bill. You will not be charged until you select
                            "Purchase" in the next screen.
                          </p>
                          <p id="payflow_error"></p>
                          <Elements
                            stripe={loadStripe(
                              `${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`
                            )}
                          >
                            <PaymentForm
                              showReviewOrderDetails={updateReviewOrderDisplay}
                              cardType={setCard}
                            />
                          </Elements>
                        </div>
                      ) : <></>}
                    </div>
                  </div>
                ) : (
                  <div className="group-radio-list">
                    <p>
                      Please select the payment method you would like to use for
                      this quote.
                    </p>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        checked={stripeSelected}
                        className="form-check-input"
                        name="radio"
                        id="stripe"
                        onChange={(event) => handleStripe(event)}
                      />
                      <label className="form-check-label" htmlFor="stripe">
                        Credit Card
                      </label>
                      {stripeSelectBidData?.aboveLimit && exceedLimitError ? (
                        <p className="error-alert">
                          This quote exceeds the limit of{" "}
                          {stripeSelectBidData?.limit?.displayWithDecimals} for
                          quotes paid by credit card. If you would like to pay by card, email us at <a href="mailto:AccountsReceivable@cloudwords.com">AccountsReceivable@cloudwords.com</a> or call +1-415-394-8012.
                        </p>
                      ) : <></>}
                      {showStripeForm ? (
                        <div>
                          <p>
                            Maximum charges for translation projects on this
                            account is{" "}
                            {stripeSelectBidData?.limit?.displayWithDecimals}. A
                            3.25% fee for credit card handling will be added to
                            your bill. You will not be charged until you select
                            "Purchase" in the next screen.
                          </p>
                          <p id="payflow_error"></p>
                          <Elements
                            stripe={loadStripe(
                              `${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`
                            )}
                          >
                            <PaymentForm
                              showReviewOrderDetails={updateReviewOrderDisplay}
                              cardType={setCard}
                            />
                          </Elements>
                        </div>
                      ) : <></>}
                    </div>
                    <div className="radio-form-check">
                      <input
                        type="radio"
                        checked={showAccountsPayableInfo}
                        className="form-check-input"
                        name="radio"
                        id="accounts-payable"
                        onChange={(event) => handleAccountsPayable(event)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="accounts-payable"
                      >
                        Accounts Payable
                      </label>
                      {showAccountsPayableInfo ? (
                        !showAccountsPayableForm ? (
                          <p>
                            Your account has not been verified yet.{" "}
                            {(customerData?.brand).toUpperCase()} will verify
                            your information within five business days from your
                            submission. If you feel this is an error, please
                            contact{" "}
                            <a href="mailto:AccountsReceivable@cloudwords.com">
                              AccountsReceivable@cloudwords.com
                            </a>{" "}
                            Or call: +1-415-394-8012.
                          </p>
                        ) : (
                          <p>
                            Verification of your accounts payable information
                            may take up to five days. If five days is too long,
                            email us at{" "}
                            <a href="mailto:AccountsReceivable@cloudwords.com">
                              AccountsReceivable@cloudwords.com
                            </a>{" "}
                            or call +1-415-394-8012.
                          </p>
                        )
                      ) : (
                        <></>
                      )}
                    </div>
                    {showAccountsPayableForm && (
                      <div className="profile-editonly-block">
                        <div className="profile-edit-form mar-bot14">
                          <div className="flex wrap-dropdown">
                            <div className="global-dropdown-block flex-center">
                              <label>Accounts Payable Contact Name</label>
                              <input
                                type="text"
                                className="form-control-sm"
                                id="apc-name"
                                title="Accounts Payable Contact Name"
                                onChange={(event) => handleAPInfo(event)}
                              />
                              <div
                                className={
                                  "error-alert upload-error" +
                                  (apNameError === true ? " show" : " hide")
                                }
                              >
                                {apNameErrorMsg}
                              </div>
                            </div>
                            <div className="global-dropdown-block flex-center">
                              <label>Accounts Payable Email</label>
                              <input
                                type="email"
                                className="form-control-sm"
                                id="apc-email"
                                title="Accounts Payable Contact Email"
                                onChange={(event) => handleAPInfo(event)}
                              />
                              <div
                                className={
                                  "error-alert upload-error" +
                                  (apEmailError === true ? " show" : " hide")
                                }
                              >
                                {apEmailErrorMsg}
                              </div>
                            </div>
                            <div className="global-dropdown-block flex-center">
                              <label>Accounts Payable Phone</label>
                              <input
                                type="text"
                                className="form-control-sm"
                                id="apc-phone"
                                title="Accounts Payable Contact Phone"
                                onChange={(event) => handleAPInfo(event)}
                              />
                              <div
                                className={
                                  "error-alert upload-error" +
                                  (apPhoneError === true ? " show" : " hide")
                                }
                              >
                                {apPhoneErrorMsg}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}

              {bidSelectionConfirmation ? bidSelectionStatus ? (
                <div className="vender-form-block">
                  Your winning vendor <b>{winningBidVendor}</b> will now start
                  on <b>{project.name}</b>. Accepting this quote cannot be
                  undone.
                </div>
              ) : <div className="vender-form-block">
              Your winning vendor <b>{winningBidVendor}</b> will now start
              on <b>{project.name}</b>. Accepting this quote cannot be
              undone. Note, your bid due date has not passed, and not all vendors have submitted bids yet. Are you sure?
            </div> : ''
              }

              {thankyouNote && (
                <div className="vender-form-block">
                  Your selected vendor has been notified and the project will
                  now proceed.
                </div>
              )}

              {acctsPayableVerificationNote && (
                <div className="vender-form-block">
                  The OPAL-Marketing Team will verify your Accounts Payable
                  information within five business days.
                </div>
              )}

              {showBack && (
                <div>
                  <p>
                    Here is a summary of your order, please confirm the
                    information below and click Purchase to select the quote. Your
                    card will be charged immediately.
                  </p>

                  <div className="table-responsive global-table border-table">
                    <table
                      className="sortable"
                      aria-label="Review Order Details"
                    >
                      <tr>
                        <td>
                          <strong>Project</strong>
                        </td>
                        <td>{stripeSelectedBid?.project?.name}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Vendor</strong>
                        </td>
                        <td>{stripeSelectedBid?.vendor?.name}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Credit Card</strong>
                        </td>
                        <td>{humanize(cardType)}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Project Cost</strong>
                        </td>
                        <td>
                          <div>
                            <span>
                              {
                                stripeSelectedBid?.totalBidCost
                                  ?.displayWithDecimals
                              }
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Credit Card Handling Fee (3.25%):</strong>
                        </td>
                        <td>
                          <div>
                            <span>
                              {
                                stripeSelectBidData?.commission
                                  ?.displayWithDecimals
                              }
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Amount to Charge:</strong>
                        </td>
                        <td>
                          <div>
                            <span>
                              {stripeSelectBidData?.due?.displayWithDecimals}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
              {showBack && (
                <>
                  <button className="btn btn-bold backBtn" onClick={handleBack}>
                    Back
                  </button>
                  <button className="btn btn-bold midFocus" onClick={purchase}>
                    Purchase
                  </button>
                </>
              )}

              {!thankyouNote && !acctsPayableVerificationNote && (
                <button
                  id="cancelSelectQuote"
                  className="btn btn-bold set-right"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              )}
              {POSelectionPopup && (
                <button
                  className="btn btn-bold active nextPopup"
                  onClick={updatePurchaseOrder}
                  disabled={selectedPO === ""}
                >
                  Next
                </button>
              )}  
             
              {paymentOptions && !showStripeForm && (
                <button
                  className="btn btn-bold active"
                  onClick={paymentMethodSelectionHandler}
                  disabled={disableNextButton || exceedLimitError}
                >
                  Next
                </button>
              )}

              {bidSelectionConfirmation && (
                <button
                  className="btn btn-bold active"
                  id="confirmBidSelection"
                  onClick={
                    !(
                      projectStatus.code === "cancelled" ||
                      projectStatus.code ===
                        "in_cancellation_waiting_for_customer"
                    )
                      ? () => acceptBid()
                      : () => acceptCancelBid()
                  }
                >
                  Confirm
                </button>
              )}

              {thankyouNote && (
                <button
                  id="okay"
                  className="btn btn-bold active"
                  onClick={finalizePayment}
                >
                  OK
                </button>
              )}

              {acctsPayableVerificationNote && (
                <button className="btn btn-bold active" onClick={handleClose}>
                  Close
                </button>
              )}
            </div>
          </div>
        </div>
      ) : ''}
    </div>
  ) : !projectDisplay.status.bidOutLaunched ? (
    !(projectDisplay.status.code === Constants.PROJECT_STATUS.PROJECT_PREPARING_TM ||
    projectDisplay.status.code === Constants.PROJECT_STATUS.EXTRACT_XLIFF_FROM_OFFLINE_FILE)
    ? (
      <div className="listing-content relative">
        <h4>
          Preparing this project for quotation(s). Check back in a few minutes.
        </h4>
      </div>
    ) : (
      <div className="listing-content relative">
        <p>
        This project has not yet been submitted for quotes.
        </p>
      </div>
    )
  ) : (
  ""
  )
}
